"use client"

import React, { useState, useEffect, useRef } from 'react';

import classNames from 'classnames';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { FilterMatchMode } from 'primereact/api';

import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import { Toast } from 'primereact/toast';
//import { InputTextarea } from 'primereact/inputtextarea';
//import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Tag } from 'primereact/tag';
import { ColorPicker } from 'primereact/colorpicker';
import { Card } from 'primereact/card';

import { Rating } from 'primereact/rating';
//import { FileUpload } from 'primereact/fileupload';

import { MultiSelect } from 'primereact/multiselect';

import { Toolbar } from 'primereact/toolbar';
import { Skeleton } from 'primereact/skeleton';
import { SelectButton } from 'primereact/selectbutton';
import { OverlayPanel } from 'primereact/overlaypanel';
import Link from 'next/link'


import { GenericaSistemaService } from '../../service/GenericaSistemaService';
import { PlantillaService } from '../../service/PlantillaService';

import AuthStorage from '../../storage/AuthStorage.js';

import Formulario from './Formulario.js';
import FormularioCalificacionRA from './FormularioCalificacionRA';
import FormularioGenerico from './FormularioGenerico';
import FormularioCalculadoraCredito from './FormularioCalculadoraCredito';
import FormularioVerificacionPagare from './FormularioVerificacionPagare';
import FormularioStep from './FormularioStep';

//import { convertHtmlToRtf } from 'html-to-rtf-browser';

import { Calendar } from 'primereact/calendar';
import { locale, addLocale } from 'primereact/api';
//import { Switch } from 'react-router-dom';
//import { render } from 'preact/compat';
//import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import lodash from "lodash";
import crypto from "crypto-js";
import { version } from 'os';



const DataTableGenerica = React.forwardRef((props, ref) => {

    console.log("DataTableGenerica,");

    const dt = useRef(null);
    const formRef = useRef(null);


    const formFacturaRef = useRef(null);
    const overlayPanelRef = useRef(null);
    const esPrimerLoad = useRef(true);

    const primerBotonRef = useRef(null);



    const codModulo = "DATATABLE_GENERICA";
    const _ = lodash;

    const plantillaService = new PlantillaService();
    const genericaSistemaService = new GenericaSistemaService();

    const authStorage = new AuthStorage(window.location.pathname);
    const userDetails = authStorage.GetCurrentUser();

    const { userName, idEmpresa, idioma } = userDetails;

    const [etiquetasModulo, setEtiquetasModulo] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [canEditRow, setCanEditRow] = useState(false);
    const [conColumnFilter, setConColumnFilter] = useState(true);


    const [optionsSelectButton, setOptionsSelectButton] = useState(undefined);
    const [comodin, setComodin] = useState(0);

    const [visibleTextButton, setVisibleTextButton] = useState(false);

    addLocale('es', {
        startsWith: 'Inicia con',
        contains: 'Contiene',
        notContains: 'No contiene',
        endsWith: 'Termina en',
        equals: 'Igual',
        notEquals: 'Diferente',
        noFilter: 'Sin filtro',
        filter: 'Filtro',
        lt: 'Menor que',
        lte: 'Menor o igual a',
        gt: 'Mayor que',
        gte: 'Mayor o igual a',
        dateIs: 'Fecha es',
        dateIsNot: 'Fecha no es',
        dateBefore: 'Fecha es anterior',
        dateAfter: 'Fecha es posterior',
        custom: 'Persolizados',
        clear: 'Limpiar',
        close: 'Cerrar',
        apply: 'Aplicar',
        matchAll: 'Coinciden todos',
        matchAny: 'Coincide alguno',
        addRule: 'Agregar regla',
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Limpiar'
    });

    locale('es');

    const prevSelectedTipoGenericaRef = useRef(undefined);

    const [filtroUtsValido, setFiltroUtsValido] = useState(true);
    const [mensajeFiltroUtsValido, setMensajeFiltroUtsValido] = useState("");
    const [selectedTipoGenerica, setSelectedTipoGenerica] = useState({});
    const [selectedTipoGenericaFormulario, setSelectedTipoGenericaFormulario] = useState(undefined);
    const [selectedTipoGenericaFormularioFactura, setSelectedTipoGenericaFormularioFactura] = useState(undefined);

    //const [selectedGenericasSistema, setSelectedGenericasSistema] = useState({'cg':'', 'cti':'', 'ctiTgTexto':'', 'ctiTg':'', 'ctiTgTexto':'', 'idEmpresa':0, 'idioma':'', 'orden':0, 'tg':''});
    const [selectedGenericasSistema, setSelectedGenericasSistema] = useState(null);

    const [genericaSistemaDialogFormulario, setGenericaSistemaDialogFormulario] = useState(false);
    const [genericaSistemaDialogFormularioFactura, setGenericaSistemaDialogFormularioFactura] = useState(false);

    const [deletegenericaSistemaDialogFormulario, setDeletegenericaSistemaDialogFormulario] = useState(false);
    const [deletegenericasSistemaDialog, setdeletegenericasSistemaDialog] = useState(false);

    const [submitted, setSubmitted] = useState(false);

    const [dialogTextVisible, setDialogTextVisible] = useState(false);

    const [versionSimplificada, setVersionSimplificada] = useState(false);
    const [canExportXLS, setCanExportXLS] = useState(true);

    const [dialogText, setDialogText] = useState("");


    //const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);

    const [validaData, setValidaData] = useState(false);

    const [metadataGenericaSistema, setMetadataGenericaSistema] = useState([]);

    const [metadataGenericaSistemaTgOperaciones, setMetadataGenericaSistemaTgOperaciones] = useState([]);

    const [metadataGenericaFormulario, setMetadataGenericaFormulario] = useState([]);
    const [metadataGenericaFormularioFactura, setMetadataGenericaFormularioFactura] = useState([]);

    let emptyGenericaSistemaInit = {
        idEmpresa: idEmpresa, id: 0, ctiTexto: "", uts: []
    };

    const [genericaFormulario, setGenericaFormulario] = useState(emptyGenericaSistemaInit);
    const [genericaFormularioFactura, setGenericaFormularioFactura] = useState(emptyGenericaSistemaInit);

    const [metadataGenericaSistemaRef, setMetadataGenericaSistemaRef] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);

    const [emptyGenericaSistema, setEmptyGenericaSistema] = useState(emptyGenericaSistemaInit);


    //const [selectAll, setSelectAll] = useState(false);

    const [genericasSistema, setGenericasSistema] = useState(null);

    const lazyParamInit = {
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null,
        iteracion: 0,
        filters: {
            'ctiTexto': { value: '', matchMode: FilterMatchMode.CONTAINS },
        }
    };

    const [lazyParams, setLazyParams] = useState(undefined);
    const lazyParamsInitSelected = useRef(Object.assign({}, lazyParamInit));


    if ((props.selectedTipoGenerica !== undefined && selectedTipoGenerica === undefined) || props.selectedTipoGenerica.tg !== selectedTipoGenerica.tg) {
        setSelectedTipoGenerica({ ...props.selectedTipoGenerica });
    }
    else {

        let newSelectedTipoGenerica = undefined;


        if (!_.isEqual(props.selectedTipoGenerica.filtroUts, selectedTipoGenerica.filtroUts)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, filtroUts: { ...props.selectedTipoGenerica.filtroUts }, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema(null);
        }
        else if (props.selectedTipoGenerica.variableRestriccionExterna !== undefined
            && !_.isEqual(props.selectedTipoGenerica.variableRestriccionExterna, selectedTipoGenerica.variableRestriccionExterna)) {
            //else if (props.selectedTipoGenerica.filtroUts !== selectedTipoGenerica.filtroUts) {
            newSelectedTipoGenerica = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version, variableRestriccionExterna: { ...props.selectedTipoGenerica.variableRestriccionExterna }, };
            setSelectedTipoGenerica(newSelectedTipoGenerica);
            setGenericasSistema(null);
        }
        else if (props.selectedTipoGenerica.version !== undefined && selectedTipoGenerica.version !== undefined && props.selectedTipoGenerica.version !== selectedTipoGenerica.version) {

            let newSelectedTipoGenerica2 = { ...selectedTipoGenerica, version: props.selectedTipoGenerica.version };
            setSelectedTipoGenerica(newSelectedTipoGenerica2);
            setGenericasSistema(null);
        }

    }

    function GetTextoEtiqueta(etiqueta) {
        return (etiquetasModulo.filter(et => et.etiqueta === etiqueta).map(et => et.ctiTexto));
    }

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }


    useEffect(() => {
        LoadEtiquetas();
    }, []);

    const LoadEtiquetas = async => {

        plantillaService.getEtiquetasModulo(codModulo, idEmpresa, idioma, "DataTableGegnerica").then(data => {
            setEtiquetasModulo(data);
        });

    }

    useEffect(() => {

        let prevselectedTipoGenerica = { ...selectedTipoGenerica }
        let isEmpty = _.isEqual({}, selectedTipoGenerica);

        if (prevSelectedTipoGenericaRef.current === undefined && selectedTipoGenerica !== undefined && !isEmpty) {
            LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
            prevselectedTipoGenerica["intentoMetadata"] = 0;
        }
        else if (prevSelectedTipoGenericaRef.current !== undefined && selectedTipoGenerica !== undefined && !isEmpty) {

            if (prevSelectedTipoGenericaRef.current.tg !== selectedTipoGenerica.tg) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = 0;
            }
            else if (metadataGenericaSistema.length === 0 && (prevSelectedTipoGenericaRef.current.intentoMetadata === undefined || prevSelectedTipoGenericaRef.current.intentoMetadata < 1)) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
                prevselectedTipoGenerica["intentoMetadata"] = prevSelectedTipoGenericaRef.current.intentoMetadata ? prevSelectedTipoGenericaRef.current.intentoMetadata + 1 : 1;
            }
            else if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA" && optionsSelectButton === undefined) {
                LoadDatosGenerica(selectedTipoGenerica.tg, idEmpresa, idioma, userName);
            }
            else {
                //console.log("setLazyParams");
                setLazyParams({ ...lazyParams });
            }

        }

        prevSelectedTipoGenericaRef.current = prevselectedTipoGenerica;

    }, [selectedTipoGenerica])

    useEffect(() => {
        // 3. Este useEffect se ejecutará cuando la tabla se pinte.
        // Si el botón ya existe en el DOM, podrás interactuar con él.

        console.log("primerBotonRef.current,", primerBotonRef.current);
        
        if (props.accionAutomaticaConRegistroUnico && esPrimerLoad.current && primerBotonRef.current) {
            esPrimerLoad.current = false;
            //console.log("¡Capturado el ref del primer botón!", primerBotonRef.current);
            // Ejemplos de uso:
            // primerBotonRef.current.focus(); // Darle foco automático
            primerBotonRef.current.click(); // Simular un clic
        }
    }, [genericasSistema]); // Se ejecuta o actualiza cada vez que cambien tus datos

    

    const LoadDatosGenerica = async (_tg, idEmpresa, idioma, userName) => {

        lazyParamInit.filters = createHeaderGenerica([{ "campo": "" }]);

        if (selectedTipoGenerica.tg !== "") {

            esPrimerLoad.current = true;

            if (selectedTipoGenerica.factorFormaDato === "CARD"
            ) {
                setVersionSimplificada(true);
                setCanExportXLS(false);
                setConColumnFilter(false);
            }


            console.log("selectedTipoGenerica.tg, ", selectedTipoGenerica.tg);

            if ((selectedTipoGenerica.operaciones === undefined || selectedTipoGenerica.operaciones.length === 0)) {

                //console.log("GetTipoGenericaSistemaByTg - Datatablegener, ", selectedTipoGenerica)
                genericaSistemaService.GetTipoGenericaSistemaByTg({ lazyEvent: JSON.stringify("") }, idEmpresa, idioma, userName, selectedTipoGenerica.tg).then(data => {

                    let newSelectedTipoGenerica = data.data;

                    if (selectedTipoGenerica.filtroUts !== undefined) {
                        newSelectedTipoGenerica.filtroUts = { ...selectedTipoGenerica.filtroUts };
                        newSelectedTipoGenerica.ctiTextoFiltroUts = selectedTipoGenerica.ctiTextoFiltroUts
                    }
                    if (selectedTipoGenerica.variableRestriccionExterna !== undefined) {
                        newSelectedTipoGenerica.variableRestriccionExterna = { ...selectedTipoGenerica.variableRestriccionExterna };
                    }
                    else {
                        newSelectedTipoGenerica.variableRestriccionExterna = {};
                    }

                    if (selectedTipoGenerica.operacionesCampos == undefined || !_.isEqual(selectedTipoGenerica.operacionesCampos, data.data.operacionesCampos)) {
                        newSelectedTipoGenerica.operacionesCampos = [...data.data.operacionesCampos];
                    }
                    if (selectedTipoGenerica.version !== undefined) {
                        newSelectedTipoGenerica.version = selectedTipoGenerica.version;
                    }

                    setSelectedTipoGenerica(newSelectedTipoGenerica);

                });
            }

            //else{}

            if (selectedTipoGenerica.operaciones !== undefined && metadataGenericaSistema.length === 0) {
                console.log("entro");
                //else if (metadataGenericaSistema.length === 0 && selectedTipoGenerica.operaciones !== undefined) {


                await genericaSistemaService.getMetadataGenericasConOperacionesDeTg(_tg, idEmpresa, idioma, userName).then(data => {




                    let columnaIdentificadorOculta = "tg";
                    let prefijo = '000000';
                    let TamSufijo = 4;
                    /*data = data.sort(function (a, b) {
                        let a1 = a.tg + '-' + (prefijo + a.orden).substring((prefijo + a.orden).length - TamSufijo) + '-' + a.campoOrigen + '-' + a.tipoDato;
                        let b1 = a.tg + '-' + (prefijo + b.orden).substring((prefijo + b.orden).length - TamSufijo) + '-' + b.campoOrigen + '-' + b.tipoDato;
                        return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
                    });*/

                    data = data.map(x => ({ ...x, formRef: null, columnRef: null, mensajeError: "" }));

                    let _metadataGenericaSistemaTgOperaciones = [...data];
                    //let _metadataGenericaSistemaTgOperaciones = data.map(x => x);
                    //setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);

                    data = data.filter(col => col.tg === _tg);

                    let metadataImprimible = data.filter(col => col.ctiConfigurado >= 0 && col.esImprimible > 0);

                    let dataForm = metadataImprimible;
                    let dataRef = data.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    let newSelectedColumns = metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)

                    if (dataRef.length > 0) {

                        setSelectedColumns([]);

                        setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                        if (_tg == "BPM_VSTA_SOLICITUD_TAREA_REQUISITO_MENSAJE") {
                            var ddd = "";
                        }
                        lazyParamInit.filters = createHeaderGenerica(dataForm);
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        //console.log("lazyParamInit, ", lazyParamInit);

                        setMetadataGenericaSistema(data);

                        setMetadataGenericaSistemaRef([...dataRef]);
                        setMetadataGenericaFormulario([...dataForm]);
                        setMetadataGenericaFormularioFactura([...dataForm]);

                        setSelectedTipoGenericaFormulario({ ...selectedTipoGenerica });
                        setSelectedTipoGenericaFormularioFactura({ ...selectedTipoGenerica });

                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;
                        setSelectedColumns([...newSelectedColumns]);

                        if (selectedTipoGenerica.operaciones) {
                            setCanEditRow(selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));
                            setValidaData(selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT"));
                        }

                        setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);
                        setGenericaFormulario({ ...emptyGenericaSistema });
                        setGenericaFormularioFactura({ ...emptyGenericaSistema });

                    }

                });

                if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA_RA" && optionsSelectButton === undefined) {

                    let tgDetalles = "ACA_VSTA_MATRICULADOS_NIVELES_DESEMPEÑO_PARA_DIGITACION_NOTA_RA";

                    await genericaSistemaService.GetOptionsSelectButtonDeTg(tgDetalles, idEmpresa, idioma, userName, selectedTipoGenerica.filtroUts).then(data => {

                        //console.log("GetOptionsSelectButtonDeTg, ", data);
                        setOptionsSelectButton(data);
                    });
                }
                else if (selectedTipoGenerica.tg !== "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA_RA" && optionsSelectButton === undefined) {
                    setOptionsSelectButton([]);
                }



            }

            if (selectedTipoGenerica.factorFormaDato === "CARD"
            ) {
                setVisibleTextButton(true);
            }

        }

    }

    const openNew = async () => {

        /*
         let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
             .filter(x => x.tg === selectedTipoGenerica.tg && x.ctiConfigurado >= 0 && x.esImprimible > 0)
             .sort((a, b) => {
                 if (a.orden > b.orden) { return 1; }
                 if (a.orden < b.orden) {
                     return -1;
                 }
                 return 0;
             });
          
         //let eventTarget = event.target;
         //let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
         //let idOpsGenerica = eventTarget[campoProps].idopsgenerica;
 
         /*let idOpsGenerica = eventTarget[campoProps].idopsgenerica;
 
         if (idOpsGenerica === undefined) {
             eventTarget = event.target.parentElement;
             campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
             idOpsGenerica = eventTarget[campoProps].idopsgenerica;
         }*/


        let idOpsGenerica = selectedTipoGenerica.operaciones.find(x => x.tipoOperacion === "NEW").id;

        console.log("idOpsGenerica, ", idOpsGenerica);

        if (idOpsGenerica !== undefined) {

            let operaciontgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                operaciontgRef = selectedTipoGenerica.operaciones[i];
                if (operaciontgRef.id === idOpsGenerica && operaciontgRef.tipoOperacion === "NEW")
                    break;
            }

            let filtroUts = {};
            let variableRestriccionExterna = {};
            let itemOpsCampo = {}

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

            let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
            datoRelacionadoVacio.id = -1;

            //Esto aplica para valores de inicio
            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {

                    if (itemOpsCampo.campoValueTg !== "" && itemOpsCampo.campoValueTg !== null && itemOpsCampo.campoValueTgRef !== null) {

                        let valueTgRef = itemOpsCampo.campoValueTgRef;
                        if (valueTgRef === "[[VAL_INIT_USERNAME]]") {
                            valueTgRef = userName;
                        }
                        else if (valueTgRef === "[[VAL_INIT_ID_TERCERO]]") {
                            valueTgRef = userName;

                            await genericaSistemaService.getIdTercero(idEmpresa, idioma, userName).then(response => {
                                valueTgRef = response;
                            });

                            var ldfdf = "";


                        }

                        filtroUts[itemOpsCampo.campoValueTg] = valueTgRef;
                        datoRelacionadoVacio.uts[itemOpsCampo.campoValueTg] = valueTgRef;
                    }

                    //
                    //filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                }
            }

            let variable = undefined;
            //let campoExterno = "";

            console.log("variable externa", selectedTipoGenerica);

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica
                    && itemOpsCampo.campoValueTg !== undefined && itemOpsCampo.campoValueTg !== ""
                    && itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {

                    if (itemOpsCampo.campoValueTg.includes("[EXTERNO")) {

                        variable = metadataGenericaSistema.find(metaData => metaData.campo === itemOpsCampo.campoValueTg);

                        if (variable !== undefined) {

                            if (selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg] !== undefined) {

                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                    "valor": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].valor,
                                    "ctiTexto": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].ctiTexto || selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].toString()
                                    //"ctiTexto": `${campoValueTg.ctiTexto}= ${selectedGenericasSistema.uts[campoValueTg].toString()}`

                                }
                            }
                            else {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                    "valor": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].valor,
                                    "ctiTexto": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].ctiTexto || selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].toString()
                                    //"ctiTexto": `${campoValueTg.ctiTexto}= ${selectedGenericasSistema.uts[campoValueTg].toString()}`

                                }
                            }

                        }
                        else {
                            if (selectedTipoGenerica.variableRestriccionExterna && selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg] !== undefined) {

                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                    "valor": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].valor,
                                    "ctiTexto": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].ctiTexto || selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].toString()
                                    //"ctiTexto": `${campoValueTg.ctiTexto}= ${selectedGenericasSistema.uts[campoValueTg].toString()}`

                                }

                            }
                            else {
                                variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                    "valor": "",
                                    "ctiTexto": "NO ENCONTRADO"
                                }
                            }
                        }

                    }


                }
            }

            var guid = window.crypto.randomUUID();

            let newSelectedTipoGenerica = {
                tg: operaciontgRef.tgRef,
                cti: operaciontgRef.ctitgRef,
                ctiTexto: operaciontgRef.ctiTextotgRef,
                orden: operaciontgRef.ordentgRef,
                cgCampo: operaciontgRef.cgCampotgRef,
                tipoOrganizacionContenido: operaciontgRef.tgRefConfig ? operaciontgRef.tgRefConfig.tipoOrganizacionContenido : 'ONE_CARD',
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: "", //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"),
                variableRestriccionExterna: variableRestriccionExterna
            }



            if (selectedTipoGenerica.filtroUts !== undefined && !_.isEqual(selectedTipoGenerica.filtroUts, {})) {
                for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === idOpsGenerica && selectedTipoGenerica.filtroUts[itemOpsCampo.campotg] !== undefined) {
                        newSelectedTipoGenerica.filtroUts[itemOpsCampo.campotgRef] = selectedTipoGenerica.filtroUts[itemOpsCampo.campotg];
                    }

                    if (itemOpsCampo.id === idOpsGenerica && newSelectedTipoGenerica.filtroUts[itemOpsCampo.campotg] !== undefined) {
                        datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = newSelectedTipoGenerica.filtroUts[itemOpsCampo.campotg];
                    }

                }

                if (selectedTipoGenerica.vistaActualizaTgRef === true || operaciontgRef.tgRef === selectedTipoGenerica.tg) {

                    ////datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

                    let camposGS = Object.keys(selectedTipoGenerica.filtroUts);
                    let camposN = Object.keys(datoRelacionadoVacio.uts);

                    let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

                    let campo = "";

                    for (let i in camposIguales) {
                        campo = camposIguales[i];
                        if (selectedTipoGenerica.filtroUts[campo] !== undefined) {

                            newSelectedTipoGenerica.filtroUts[campo] = selectedTipoGenerica.filtroUts[campo];
                            datoRelacionadoVacio.uts[campo] = selectedTipoGenerica.filtroUts[campo];
                            console.log("Campo,", campo, selectedTipoGenerica.filtroUts[campo], typeof selectedTipoGenerica.filtroUts[campo]);
                        }
                    }

                }

            }

            console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
            console.log("datoRelacionadoVacioReportar, ", datoRelacionadoVacio);
            console.log("metadataTgOperacion,", metadataTgOperacion);
            //console.log("genericaSistema,", genericaSistema);

            if (operaciontgRef.tgRef === "BPM_VSTA_SOLICITUD_GEN_ASESOR_MOD_NEW_STEP11") {
                console.log("OPS", operaciontgRef);

                setSelectedTipoGenericaFormularioFactura(newSelectedTipoGenerica);
                setMetadataGenericaFormularioFactura(metadataTgOperacion);
                setGenericaFormularioFactura(datoRelacionadoVacio);
                setGenericaSistemaDialogFormularioFactura(true);
                setSubmitted(false);

            }

            else {

                setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
                setMetadataGenericaFormulario(metadataTgOperacion);
                setGenericaFormulario(datoRelacionadoVacio);
                setGenericaSistemaDialogFormulario(true);
                setSubmitted(false);

            }



        }
        else {

        }


    }

    const copyGenerica = async () => {

        let genericaSistema = selectedGenericasSistema;
        /*
        let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
            .filter(x => x.tg === selectedTipoGenerica.tg && x.ctiConfigurado >= 0 && x.esImprimible > 0)
            .sort((a, b) => {
                if (a.orden > b.orden) { return 1; }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });
            */

        let idOpsGenerica = selectedTipoGenerica.operaciones.find(x => x.tipoOperacion === "COPY").id;
        console.log("idOpsGenerica COPY, ", idOpsGenerica);

        if (idOpsGenerica !== undefined) {

            let operaciontgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                operaciontgRef = selectedTipoGenerica.operaciones[i];
                if (operaciontgRef.id === idOpsGenerica)//&& operaciontgRef.tipoOperacion === "EDIT")
                    break;
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
                .filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

            if (selectedTipoGenerica.vistaActualizaTgRef === true || operaciontgRef.tgRef === selectedTipoGenerica.tg) {

                await genericaSistemaService.getGenericaSistemaById(idEmpresa, idioma, userName, operaciontgRef.tgRef, genericaSistema.id).then(response => {

                    //let datoGenTgRef = response.data;

                    let filtroUts = {};
                    let variableRestriccionExterna = {};
                    let itemOpsCampo = {};

                    let ctiTextoFiltroUts = "";

                    let metadataGen = {};
                    let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);

                    metadataTgOperacion//.find(x => x.requeridoParaNuevo === true)
                        .forEach(metadataGen => {
                            if (metadataGen.tipoDato !== "sequence") {
                                datoRelacionadoVacio.uts[metadataGen.campo] = genericaSistema.uts[metadataGen.campo];
                            }
                        });

                    datoRelacionadoVacio.id = -1;
                    datoRelacionadoVacio.indexRow = -1;

                    /*  no debería ser necesario porque estamos clonando data
                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === idOpsGenerica) {
                            filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                            datoRelacionadoVacio.uts[itemOpsCampo.campotg] = genericaSistema.uts[itemOpsCampo.campotg];

                            if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                                ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                            }

                        }
                    }

                    let camposGS = Object.keys(genericaSistema.uts);
                    let camposN = Object.keys(datoGenTgRef.uts);

                    let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

                    let campo = "";

                    for (let i in camposIguales) {

                        campo = camposIguales[i];

                        datoGenTgRef.uts[campo] = genericaSistema.uts[campo];

                        //filtroUts[campo] = genericaSistema.uts[campo];
                        if (genericaSistema.uts[`ctiTexto${campo}`] !== undefined) {
                            ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${campo}`];
                        }

                    }

                    ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);
                    
                    let variable = undefined;
                    //let campoExterno = "";
                    
                    console.log("variable externa", selectedTipoGenerica);
                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === idOpsGenerica
                            && itemOpsCampo.campoValueTg !== undefined && itemOpsCampo.campoValueTg !== ""
                            && itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {

                            variable = metadataGenericaSistema.find(metaData => metaData.campo === itemOpsCampo.campoValueTg);

                            if (variable !== undefined) {

                                if (selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg] !== undefined) {

                                    variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                        "valor": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].valor,
                                        "ctiTexto": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].ctiTexto ||  selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].toString()
                                        //"ctiTexto": `${campoValueTg.ctiTexto}= ${selectedGenericasSistema.uts[campoValueTg].toString()}`

                                    }
                                }
                                else if (genericaSistema.uts[itemOpsCampo.campoValueTg] !== undefined) {
                                    variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                        "valor": genericaSistema.uts[itemOpsCampo.campoValueTg].valor,
                                        "ctiTexto":  selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].ctiTexto || genericaSistema.uts[itemOpsCampo.campoValueTg].toString()
                                        //"ctiTexto": `${campoValueTg.ctiTexto}= ${selectedGenericasSistema.uts[campoValueTg].toString()}`

                                    }
                                }

                            }
                            else {
                                if (selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg] !== undefined) {

                                    variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                        "valor": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].valor,
                                        "ctiTexto": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].toString()
                                        //"ctiTexto": `${campoValueTg.ctiTexto}= ${selectedGenericasSistema.uts[campoValueTg].toString()}`

                                    }

                                }
                                else {
                                    variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                        "valor": "",
                                        "ctiTexto": "NO ENCONTRADO"
                                    }
                                }
                            }

                        }
                    }
                    */

                    var guid = window.crypto.randomUUID();

                    let newSelectedTipoGenerica = {
                        tg: operaciontgRef.tgRef,
                        cti: operaciontgRef.ctitgRef,
                        ctiTexto: operaciontgRef.ctiTextotgRef,
                        orden: operaciontgRef.ordentgRef,
                        cgCampo: operaciontgRef.cgCampotgRef,
                        operaciones: undefined,
                        version: guid,
                        variableRestriccionExterna: { ...selectedTipoGenerica.variableRestriccionExterna },
                        filtroUts: { ...selectedTipoGenerica.filtroUts },
                        ctiTextoFiltroUts: selectedTipoGenerica.ctiTextoFiltroUts

                    }


                    //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

                    console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
                    //console.log("metadataTgOperacion,", metadataTgOperacion);
                    console.log("datoRelacionadoVacio,", datoRelacionadoVacio);

                    setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
                    setMetadataGenericaFormulario([...metadataTgOperacion]);
                    setGenericaFormulario(datoRelacionadoVacio);
                    setGenericaSistemaDialogFormulario(true);

                });

            }
            else {

                let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
                datoRelacionadoVacio.id = genericaSistema.id;
                //datoRelacionadoVacio.uts = {}

                let filtroUts = {};
                let itemOpsCampo = {};
                let ctiTextoFiltroUts = "";

                for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === idOpsGenerica) {
                        filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                        datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                        if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                            ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                        }

                    }
                }

                ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

                var guid = window.crypto.randomUUID();
                let newSelectedTipoGenerica = {
                    tg: operaciontgRef.tgRef,
                    cti: operaciontgRef.ctitgRef,
                    ctiTexto: operaciontgRef.ctiTextotgRef,
                    orden: operaciontgRef.ordentgRef,
                    cgCampo: operaciontgRef.cgCampotgRef,
                    operaciones: undefined,
                    version: guid,
                    filtroUts: filtroUts,
                    ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),
                }

                //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

                let camposGS = Object.keys(genericaSistema.uts);
                let camposN = Object.keys(datoRelacionadoVacio.uts);

                let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

                let campo = "";

                for (let i in camposIguales) {

                    campo = camposIguales[i];
                    datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
                }

                console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
                //console.log("metadataTgOperacion,", metadataTgOperacion);
                console.log("datoRelacionadoVacio,", datoRelacionadoVacio);

                setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
                setMetadataGenericaFormulario(metadataTgOperacion);
                setGenericaFormulario(datoRelacionadoVacio);
                setGenericaSistemaDialogFormulario(true);

            }

        }
        else {

        }


    }

    const deleteSelectedgenericasSistema = async () => {


        console.log("deleteSelectedgenericasSistema");
        /*
        let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
            .filter(x => x.tg === selectedTipoGenerica.tg && x.ctiConfigurado >= 0 && x.esImprimible > 0)
            .sort((a, b) => {
                if (a.orden > b.orden) { return 1; }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });
            */

        //let eventTarget = event.target;
        //let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        //let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        /*let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }*/

        let idOpsGenerica = selectedTipoGenerica.operaciones.find(x => x.tipoOperacion === "REMOVE").id;

        console.log("idOpsGenerica, ", idOpsGenerica);

        if (idOpsGenerica !== undefined) {
            let tgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                tgRef = selectedTipoGenerica.operaciones[i];
                if (tgRef.id === idOpsGenerica && tgRef.tipoOperacion === "REMOVE")
                    break;
            }

            let filtroUts = {};
            let itemOpsCampo = {};

            /*
            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                }
            }*/

            var guid = window.crypto.randomUUID();

            let newSelectedTipoGenerica = {
                tg: tgRef.tgRef,
                cti: tgRef.ctitgRef,
                ctiTexto: tgRef.ctiTextotgRef,
                orden: tgRef.ordentgRef,
                cgCampo: tgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: "" //selectedTipoGenerica.ctiTexto + ": " + (Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO")
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === tgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
            datoRelacionadoVacio.id = selectedGenericasSistema.id;

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    if (selectedTipoGenerica.filtroUts !== undefined && selectedTipoGenerica.filtroUts[itemOpsCampo.campotg] !== undefined) {
                        newSelectedTipoGenerica.filtroUts[itemOpsCampo.campotgRef] = selectedTipoGenerica.filtroUts[itemOpsCampo.campotg];
                        datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = selectedGenericasSistema.uts[itemOpsCampo.campotg];
                    }

                }
            }

            //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

            /*
            let camposGS = Object.keys(genericaSistema.uts);
            let camposN = Object.keys(datoRelacionadoVacio.uts);

            let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

            let campo = "";

            for (let i in camposIguales) {

                campo = camposIguales[i];
                datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
                console.log("Campo,", campo, genericaSistema.uts[campo], typeof genericaSistema.uts[campo]);  
            }
            */

            console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
            console.log("datoRelacionadoVacioReportar, ", datoRelacionadoVacio);

            await genericaSistemaService.removeGenericaSistema(idEmpresa, idioma, userName, datoRelacionadoVacio).then(response => {
                let _genericasSistema = genericasSistema.filter(val => val.id !== selectedGenericasSistema.id);
                setGenericasSistema(_genericasSistema);
                setdeletegenericasSistemaDialog(false);
                setSelectedGenericasSistema(null);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'genericasSistema Deleted', life: 3000 });

            });

        }
    }


    const hideDialog = () => {
        setSubmitted(false);
        setGenericaSistemaDialogFormulario(false);
        setGenericaSistemaDialogFormularioFactura(false);
    }

    const hidedeletegenericaSistemaDialogFormulario = () => {
        setDeletegenericaSistemaDialogFormulario(false);
    }

    const hidedeletegenericasSistemaDialog = () => {
        setdeletegenericasSistemaDialog(false);
    }

    const sendMailGenerica = async (e, rowData) => {

        //let { rowData, newValue, field, originalEvent: event } = e;

        // validaciones varias que aún están programadas.

        setSubmitted(true);
        setLoading(true);

        //[field] = newValue;

        let tgRefOps = selectedTipoGenerica.operacionesCampos.find(x => x.tipoOperacion === "SEND_EMAIL")

        let genericaSistema = { id: rowData.id, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }

        let itemOpsCampo = {};

        for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
            itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
            if (itemOpsCampo.id === tgRefOps.id) {
                genericaSistema.uts[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];
            }
        }
        //genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

        console.log("sendemail, ", genericaSistema);

        await genericaSistemaService.sendEmail(idEmpresa, idioma, userName, genericaSistema).then(response => {

            console.log("response, ", response);

            let genericaSistemaAffect = response.genericasSistemaAffected[0];

            if (selectedTipoGenerica.tg === genericaSistemaAffect.tg) {

                if (response.mensaje === "") {

                    if (rowData.id > 0) {
                        //rowData.uts[field] = newValue;
                        rowData.uts = genericaSistemaAffect.uts;
                    }
                    else {
                        rowData.id = genericaSistemaAffect.id;
                        rowData.cti = genericaSistemaAffect.cti;
                        //rowData.uts[field] = newValue;
                        rowData.uts = genericaSistemaAffect.uts;

                        /*const index = findIndexById(rowData.id);
                        let _genericasSistema = [...genericasSistema]
 
                        _genericasSistema[index].id = response.id;
                        _genericasSistema[index].cti = response.cti;
                        if (response.campoSequenceTg!=="")
                        _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
 
                        setGenericasSistema(_genericasSistema);*/

                        //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                        //_genericasSistema.unshift(_genericaSistema);
                    }




                    //setGenericaSistemaDialogFormulario(false);
                    //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                }
                else {

                    if (rowData.id > 0) {
                        //rowData.uts[field] = newValue;
                        //rowData.uts  = genericaSistemaAffect.uts;
                    }
                    else {
                        rowData.id = response.id;
                        rowData.cti = response.cti;
                        if (response.campoSequenceTg !== "")
                            rowData.uts[response.campoSequenceTg] = response.sequenceTg;
                        //rowData.uts[field] = newValue;

                        /*const index = findIndexById(rowData.id);
                        let _genericasSistema = [...genericasSistema]
 
                        _genericasSistema[index].id = response.id;
                        _genericasSistema[index].cti = response.cti;
                        if (response.campoSequenceTg!=="")
                        _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
 
                        setGenericasSistema(_genericasSistema);*/

                        //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                        //_genericasSistema.unshift(_genericaSistema);
                    }

                }

                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });

            }
            else {
                toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
            }

        });

        /*
        switch (field) {
            case 'quantity':
            case 'price':
                if (isPositiveInteger(newValue)) rowData.uts[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData.uts[field] = newValue;
                else event.preventDefault();
                break;
        }*/

        setLoading(false);

    };


    const editGenericaSistemaFormulario = async (event, genericaSistema) => {

        console.log("editGenericaSistemaFormulario, ", genericaSistema);
        /*
        let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
            .filter(x => x.tg === selectedTipoGenerica.tg && x.ctiConfigurado >= 0 && x.esImprimible > 0)
            .sort((a, b) => {
                if (a.orden > b.orden) { return 1; }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });
            */

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {

            let operaciontgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                operaciontgRef = selectedTipoGenerica.operaciones[i];
                if (operaciontgRef.id === idOpsGenerica)//&& operaciontgRef.tipoOperacion === "EDIT")
                    break;
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
                .filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && (x.esImprimible > 0 || x.esSoloLectura > 0));

            if (selectedTipoGenerica.vistaActualizaTgRef === true || operaciontgRef.tgRef === selectedTipoGenerica.tg) {

                await genericaSistemaService.getGenericaSistemaById(idEmpresa, idioma, userName, operaciontgRef.tgRef, genericaSistema.id)
                    .then(response => {

                        let datoGenTgRef = response.data;

                        let filtroUts = {};
                        let variableRestriccionExterna = {};
                        let itemOpsCampo = {};

                        let ctiTextoFiltroUts = "";

                        for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                            itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                            if (itemOpsCampo.id === idOpsGenerica) {
                                filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                                datoGenTgRef.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                                if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                                    ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                                }

                            }
                        }

                        let camposGS = Object.keys(genericaSistema.uts);
                        let camposN = Object.keys(datoGenTgRef.uts);

                        let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

                        //Campos de trasladables por operación
                        let camposNoTrasladables = "";

                        if (operaciontgRef.tgRef === "BPM_VSTA_SOLICITUD_CD_INVITADO_DATO_PERSONAL") { camposNoTrasladables = "requisitoTarea"; }

                        let camposNT = camposNoTrasladables.split(",");

                        camposIguales = camposIguales.filter(x => !camposNT.some(y => x === y));

                        let campo = "";

                        for (let i in camposIguales) {

                            campo = camposIguales[i];

                            datoGenTgRef.uts[campo] = genericaSistema.uts[campo];

                            //filtroUts[campo] = genericaSistema.uts[campo];
                            if (genericaSistema.uts[`ctiTexto${campo}`] !== undefined) {
                                ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${campo}`];
                            }

                        }

                        ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

                        let variable = undefined;
                        //let campoExterno = "";

                        console.log("variable externa", selectedTipoGenerica);
                        for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                            itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                            if (itemOpsCampo.id === idOpsGenerica
                                && itemOpsCampo.campoValueTg !== undefined && itemOpsCampo.campoValueTg !== ""
                                && itemOpsCampo.campoValueTgRef !== undefined && itemOpsCampo.campoValueTgRef !== "") {

                                variable = metadataGenericaSistema.find(metaData => metaData.campo === itemOpsCampo.campoValueTg);

                                if (variable !== undefined) {

                                    if (selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg] !== undefined) {

                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                            "valor": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].valor,
                                            "ctiTexto": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].toString()
                                            //"ctiTexto": `${campoValueTg.ctiTexto}= ${selectedGenericasSistema.uts[campoValueTg].toString()}`

                                        }
                                    }
                                    else if (genericaSistema.uts[itemOpsCampo.campoValueTg] !== undefined) {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                            "valor": genericaSistema.uts[itemOpsCampo.campoValueTg],
                                            "ctiTexto": genericaSistema.uts[itemOpsCampo.campoValueTg].toString()
                                            //"ctiTexto": `${campoValueTg.ctiTexto}= ${selectedGenericasSistema.uts[campoValueTg].toString()}`

                                        }
                                    }

                                }
                                else {
                                    if (selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg] !== undefined) {

                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                            "valor": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].valor,
                                            "ctiTexto": selectedTipoGenerica.variableRestriccionExterna[itemOpsCampo.campoValueTg].toString()
                                            //"ctiTexto": `${campoValueTg.ctiTexto}= ${selectedGenericasSistema.uts[campoValueTg].toString()}`

                                        }

                                    }
                                    else {
                                        variableRestriccionExterna[itemOpsCampo.campoValueTgRef] = {
                                            "valor": "",
                                            "ctiTexto": "NO ENCONTRADO"
                                        }
                                    }
                                }

                            }
                        }

                        var guid = window.crypto.randomUUID();

                        let newSelectedTipoGenerica = {
                            tg: operaciontgRef.tgRef,
                            cti: operaciontgRef.ctitgRef,
                            ctiTexto: operaciontgRef.ctiTextotgRef,
                            orden: operaciontgRef.ordentgRef,
                            cgCampo: operaciontgRef.cgCampotgRef,
                            operaciones: undefined,
                            version: guid,
                            variableRestriccionExterna: { ...variableRestriccionExterna },
                            filtroUts: filtroUts,
                            ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),

                        }


                        //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

                        console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
                        //console.log("metadataTgOperacion,", metadataTgOperacion);
                        console.log("datoRelacionadoVacio,", datoGenTgRef);

                        setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
                        setMetadataGenericaFormulario(metadataTgOperacion);
                        setGenericaFormulario(datoGenTgRef);
                        setGenericaSistemaDialogFormulario(true);

                    });

            }
            else {

                let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
                datoRelacionadoVacio.id = genericaSistema.id;
                //datoRelacionadoVacio.uts = {}

                let filtroUts = {};
                let itemOpsCampo = {};
                let ctiTextoFiltroUts = "";

                for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === idOpsGenerica) {
                        filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                        datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                        if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                            ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                        }

                    }
                }

                ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

                var guid = window.crypto.randomUUID();
                let newSelectedTipoGenerica = {
                    tg: operaciontgRef.tgRef,
                    cti: operaciontgRef.ctitgRef,
                    ctiTexto: operaciontgRef.ctiTextotgRef,
                    orden: operaciontgRef.ordentgRef,
                    cgCampo: operaciontgRef.cgCampotgRef,
                    operaciones: undefined,
                    version: guid,
                    filtroUts: filtroUts,
                    ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),
                }

                //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

                let camposGS = Object.keys(genericaSistema.uts);
                let camposN = Object.keys(datoRelacionadoVacio.uts);

                let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

                let campo = "";

                for (let i in camposIguales) {

                    campo = camposIguales[i];
                    datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
                }

                console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
                //console.log("metadataTgOperacion,", metadataTgOperacion);
                console.log("datoRelacionadoVacio,", datoRelacionadoVacio);

                setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
                setMetadataGenericaFormulario(metadataTgOperacion);
                setGenericaFormulario(datoRelacionadoVacio);
                setGenericaSistemaDialogFormulario(true);

            }

        }
        else {

        }


    }

    const editGenericaSistemaFormularioFactura = async (event, genericaSistema) => {

        console.log("editGenericaSistemaFormularioFactura,");
        /*
        let metadataTgOperacion = metadataGenericaSistemaTgOperaciones
            .filter(x => x.tg === selectedTipoGenerica.tg && x.ctiConfigurado >= 0 && x.esImprimible > 0)
            .sort((a, b) => {
                if (a.orden > b.orden) { return 1; }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });
            */

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {

            let operaciontgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                operaciontgRef = selectedTipoGenerica.operaciones[i];
                if (operaciontgRef.id === idOpsGenerica)//&& operaciontgRef.tipoOperacion === "EDIT")
                    break;
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === operaciontgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            if (operaciontgRef.tgRef === selectedTipoGenerica.tg) {

                await genericaSistemaService.getGenericaSistemaById(idEmpresa, idioma, userName, operaciontgRef.tgRef, genericaSistema.id).then(response => {

                    let datoGenTgRef = response.data;

                    let filtroUts = {};
                    let itemOpsCampo = {};
                    let ctiTextoFiltroUts = "";

                    for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                        itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                        if (itemOpsCampo.id === idOpsGenerica) {
                            filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                            datoGenTgRef.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                            if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                                ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                            }

                        }
                    }

                    ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

                    var guid = window.crypto.randomUUID();

                    let newSelectedTipoGenerica = {
                        tg: operaciontgRef.tgRef,
                        cti: operaciontgRef.ctitgRef,
                        ctiTexto: operaciontgRef.ctiTextotgRef,
                        orden: operaciontgRef.ordentgRef,
                        cgCampo: operaciontgRef.cgCampotgRef,
                        operaciones: undefined,
                        version: guid,
                        tipoOrganizacionContenido: operaciontgRef.tgRefConfig ? operaciontgRef.tgRefConfig.tipoOrganizacionContenido : 'ONE_CARD',
                        filtroUts: filtroUts,
                        ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),

                    }

                    let camposGS = Object.keys(genericaSistema.uts);
                    let camposN = Object.keys(datoGenTgRef.uts);

                    let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

                    let campo = "";

                    for (let i in camposIguales) {

                        campo = camposIguales[i];
                        datoGenTgRef.uts[campo] = genericaSistema.uts[campo];
                    }


                    //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

                    console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
                    //console.log("metadataTgOperacion,", metadataTgOperacion);
                    console.log("datoRelacionadoVacio,", datoGenTgRef);

                    setSelectedTipoGenericaFormularioFactura(newSelectedTipoGenerica);
                    setMetadataGenericaFormularioFactura(metadataTgOperacion);
                    setGenericaFormularioFactura(datoGenTgRef);
                    setGenericaSistemaDialogFormularioFactura(true);

                });

            }
            else {

                let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
                datoRelacionadoVacio.id = genericaSistema.id;
                //datoRelacionadoVacio.uts = {}

                let filtroUts = {};
                let itemOpsCampo = {};
                let ctiTextoFiltroUts = "";

                for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                    itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                    if (itemOpsCampo.id === idOpsGenerica) {
                        filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                        datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                        if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                            ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                        }

                    }
                }

                ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

                var guid = window.crypto.randomUUID();
                let newSelectedTipoGenerica = {
                    tg: operaciontgRef.tgRef,
                    cti: operaciontgRef.ctitgRef,
                    ctiTexto: operaciontgRef.ctiTextotgRef,
                    orden: operaciontgRef.ordentgRef,
                    cgCampo: operaciontgRef.cgCampotgRef,
                    operaciones: undefined,
                    version: guid,
                    tipoOrganizacionContenido: operaciontgRef.tgRefConfig ? operaciontgRef.tgRefConfig.tipoOrganizacionContenido : 'ONE_CARD',
                    filtroUts: filtroUts,
                    ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),
                }

                //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

                let camposGS = Object.keys(genericaSistema.uts);
                let camposN = Object.keys(datoRelacionadoVacio.uts);

                let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

                let campo = "";

                for (let i in camposIguales) {

                    campo = camposIguales[i];
                    datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
                }

                console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
                //console.log("metadataTgOperacion,", metadataTgOperacion);
                console.log("datoRelacionadoVacio,", datoRelacionadoVacio);

                setSelectedTipoGenericaFormularioFactura(newSelectedTipoGenerica);
                setMetadataGenericaFormularioFactura(metadataTgOperacion);
                setGenericaFormularioFactura(datoRelacionadoVacio);
                setGenericaSistemaDialogFormularioFactura(true);

            }

        }
        else {

        }


    }



    const editGenericaSistemaFormularioFactura2 = (event, genericaSistema) => {

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {
            let tgRef = {};

            let operaciontgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                operaciontgRef = selectedTipoGenerica.operaciones[i];
                if (operaciontgRef.id === idOpsGenerica) //&& operaciontgRef.tipoOperacion === "EDIT")
                    break;
            }


            let filtroUts = {};
            let itemOpsCampo = {};
            let ctiTextoFiltroUts = "";

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                    if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                        ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                    }

                }
            }

            ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

            var guid = window.crypto.randomUUID();
            let newSelectedTipoGenerica = {
                tg: tgRef.tgRef,
                cti: tgRef.ctitgRef,
                ctiTexto: tgRef.ctiTextotgRef,
                orden: tgRef.ordentgRef,
                cgCampo: tgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),
            }

            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === tgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
            datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

            let camposGS = Object.keys(genericaSistema.uts);
            let camposN = Object.keys(datoRelacionadoVacio.uts);

            let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

            let campo = "";

            for (let i in camposIguales) {

                campo = camposIguales[i];
                datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
            }

            console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
            console.log("metadataTgOperacion,", metadataTgOperacion);
            console.log("genericaSistema,", genericaSistema);

            setSelectedTipoGenericaFormularioFactura(newSelectedTipoGenerica);
            setMetadataGenericaFormularioFactura(metadataTgOperacion);
            setGenericaFormularioFactura(datoRelacionadoVacio);
            setGenericaSistemaDialogFormularioFactura(true);

        }
        else {

        }

    }

    const reportarEvidencia = (event, genericaSistema) => {
        console.log("reportarEvidencia,");

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {
            let tgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                tgRef = selectedTipoGenerica.operaciones[i];
                if (tgRef.id === idOpsGenerica) // && (tgRef.tipoOperacion === "REPORT" || tgRef.tipoOperacion === "_ROW_REPORT"))
                    break;
            }


            let filtroUts = {};
            let itemOpsCampo = {};



            let metadataTgOperacion = metadataGenericaSistemaTgOperaciones.filter(x => x.tg === tgRef.tgRef && x.ctiConfigurado >= 0 && x.esImprimible > 0);

            let datoRelacionadoVacio = crearNewEmptyGenerica(metadataTgOperacion);
            let ctiTextoFiltroUts = "";

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                    datoRelacionadoVacio.uts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                    if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                        ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                    }
                }
            }

            ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

            let variableRestriccionExterna = {};
            let variable = undefined;


            //console.log("metadataTgOperacion, ", metadataTgOperacion, metadataTgOperacion.filter(x=> x.restriccionFormatoMax !== null && x.restriccionFormatoMax.includes("[[EXTERNO_") ));

            //console.log("encontrado, ",   metadataTgOperacion.filter(x=> x.restriccionFormatoMax !== null && x.restriccionFormatoMax.includes("[[EXTERNO_") ));

            metadataTgOperacion.filter(x => (x.restriccionFormatoMax !== null && x.restriccionFormatoMax.includes("[[EXTERNO_")) || (x.restriccionFormatoMin !== null && x.restriccionFormatoMin.includes("[[EXTERNO_"))
            ).forEach(campoExterno => {

                variable = metadataGenericaSistema.find(metaData => `[[EXTERNO_${metaData.campo}]]` === campoExterno.restriccionFormatoMax);

                if (variable !== undefined) {

                    variableRestriccionExterna[`[[EXTERNO_${variable.campo}]]`] = {
                        "valor": genericaSistema.uts[variable.campo],
                        "ctiTexto": `${variable.ctiTexto}= ${genericaSistema.uts[variable.campo].toString()}`
                    }

                }
                else {
                    variable = metadataGenericaSistema.find(metaData => `[[EXTERNO_${metaData.campo}]]` === campoExterno.restriccionFormatoMin);

                    if (variable !== undefined) {
                        variableRestriccionExterna[`[[EXTERNO_${variable.campo}]]`] = {
                            "valor": genericaSistema.uts[variable.campo],
                            "ctiTexto": `${campoExterno.campo}= ${genericaSistema.uts[variable.campo].toString()}`
                        }
                    }
                }


            });

            var guid = window.crypto.randomUUID();

            let newSelectedTipoGenerica = {
                tg: tgRef.tgRef,
                cti: tgRef.ctitgRef,
                ctiTexto: tgRef.ctiTextotgRef,
                orden: tgRef.ordentgRef,
                cgCampo: tgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),
                variableRestriccionExterna: variableRestriccionExterna
            }

            //datoRelacionadoVacio.uts[newSelectedTipoGenerica.cgCampo] = genericaSistema.uts[selectedTipoGenerica.cgCampo];

            let camposGS = Object.keys(genericaSistema.uts);
            let camposN = Object.keys(datoRelacionadoVacio.uts);

            let camposIguales = camposN.filter(x => camposGS.some(y => x === y));

            let campo = "";

            for (let i in camposIguales) {

                campo = camposIguales[i];
                datoRelacionadoVacio.uts[campo] = genericaSistema.uts[campo];
            }

            console.log("newSelectedTipoGenericaReportar, ", newSelectedTipoGenerica);
            console.log("metadataTgOperacion,", metadataTgOperacion);
            //console.log("genericaSistema,", genericaSistema);

            /*
            setSelectedTipoGenericaFormularioFactura(newSelectedTipoGenerica);
            setMetadataGenericaFormularioFactura(metadataTgOperacion);
            setGenericaFormularioFactura(datoRelacionadoVacio);
            setGenericaSistemaDialogFormularioFactura(true);*/

            setSelectedTipoGenericaFormulario(newSelectedTipoGenerica);
            setMetadataGenericaFormulario(metadataTgOperacion);
            setGenericaFormulario(datoRelacionadoVacio);
            setGenericaSistemaDialogFormulario(true);

        }
        else {

        }

    }

    const verListaAsociada = async (event, genericaSistema) => {

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {

            let operaciontgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                operaciontgRef = selectedTipoGenerica.operaciones[i];
                if (operaciontgRef.id === idOpsGenerica)
                    break;
            }

            let filtroUts = {};
            let itemOpsCampo = {};
            let ctiTextoFiltroUts = "";

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                    //filtroUts[`ctiTexto${itemOpsCampo.campotgRef}`] = Object.keys(genericaSistema.uts).includes(`ctiTexto${itemOpsCampo.campotg}`) ? genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] : genericaSistema.uts['ctiTexto'] || selectedTipoGenerica.ctiTexto;

                    if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                        ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                    }

                }
            }

            //Esto aplica para valores de inicio
            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {

                    if (itemOpsCampo.campoValueTg !== "" && itemOpsCampo.campoValueTg !== null && itemOpsCampo.campoValueTgRef !== null) {

                        let valueTgRef = itemOpsCampo.campoValueTgRef;
                        if (valueTgRef === "[[VAL_INIT_USERNAME]]") {
                            valueTgRef = userName;
                        }
                        else if (valueTgRef === "[[VAL_INIT_ID_TERCERO]]") {
                            valueTgRef = userName;

                            await genericaSistemaService.getIdTercero(idEmpresa, idioma, userName).then(response => {
                                valueTgRef = response;
                            });

                            var ldfdf = "";


                        }

                        filtroUts[itemOpsCampo.campoValueTg] = valueTgRef;
                        //datoRelacionadoVacio.uts[itemOpsCampo.campoValueTg] = valueTgRef;
                    }

                    //
                    //filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];
                }
            }


            ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

            var guid = window.crypto.randomUUID();
            let newSelectedTipoGenerica = {
                tg: operaciontgRef.tgRef,
                categoriaTg: operaciontgRef.categoriaTgRef,
                tipoOrganizacionContenido: operaciontgRef.tgRefConfig ? operaciontgRef.tgRefConfig.tipoOrganizacionContenido : 'ONE_CARD',
                cti: operaciontgRef.ctitgRef,
                ctiTexto: operaciontgRef.ctiTextotgRef,
                orden: operaciontgRef.ordentgRef,
                cgCampo: operaciontgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),

                // estos aún tiene mejora
            }

            let nameEventPadre = (props.codMenu + "-" + operaciontgRef.id + "-" + JSON.stringify(newSelectedTipoGenerica.filtroUts)).toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(" ", "_");


            console.log("genericaSistema.uts, ", genericaSistema.uts, "lista nueva, ", newSelectedTipoGenerica);

            let eventPadre = { item: { name: nameEventPadre, codMenu: props.codMenu, level: props.level + 1, selectedTipoGenerica: newSelectedTipoGenerica, label: operaciontgRef.ctiTextotgRef } }
            props.addSubTabMenu(eventPadre);

        }

        else {

        }

    }

    const verReport = async (event, genericaSistema) => {

        let eventTarget = event.target;
        let campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
        let idOpsGenerica = eventTarget[campoProps].idopsgenerica;

        if (idOpsGenerica === undefined) {
            eventTarget = event.target.parentElement;
            campoProps = Object.keys(eventTarget).find(x => x.includes("__reactProps"));
            idOpsGenerica = eventTarget[campoProps].idopsgenerica;
        }

        if (idOpsGenerica !== undefined) {

            let operaciontgRef = {};

            for (let i = 0; i < selectedTipoGenerica.operaciones.length; i++) {
                operaciontgRef = selectedTipoGenerica.operaciones[i];
                if (operaciontgRef.id === idOpsGenerica)
                    break;
            }

            let filtroUts = {};
            let itemOpsCampo = {};
            let ctiTextoFiltroUts = "";

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === idOpsGenerica) {
                    filtroUts[itemOpsCampo.campotgRef] = genericaSistema.uts[itemOpsCampo.campotg];

                    //filtroUts[`ctiTexto${itemOpsCampo.campotgRef}`] = Object.keys(genericaSistema.uts).includes(`ctiTexto${itemOpsCampo.campotg}`) ? genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] : genericaSistema.uts['ctiTexto'] || selectedTipoGenerica.ctiTexto;

                    if (genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`] !== undefined) {
                        ctiTextoFiltroUts += ", " + genericaSistema.uts[`ctiTexto${itemOpsCampo.campotg}`];
                    }

                }
            }

            ctiTextoFiltroUts = ctiTextoFiltroUts.substring(2, ctiTextoFiltroUts.length);

            var guid = window.crypto.randomUUID();
            let newSelectedTipoGenerica = {
                tg: operaciontgRef.tgRef,
                categoriaTg: operaciontgRef.categoriaTgRef,
                tipoOrganizacionContenido: operaciontgRef.tgRefConfig ? operaciontgRef.tgRefConfig.tipoOrganizacionContenido : 'ONE_CARD',
                cti: operaciontgRef.ctitgRef,
                ctiTexto: operaciontgRef.ctiTextotgRef,
                orden: operaciontgRef.ordentgRef,
                cgCampo: operaciontgRef.cgCampotgRef,
                operaciones: undefined,
                version: guid,
                filtroUts: filtroUts,
                ctiTextoFiltroUts: selectedTipoGenerica.ctiTexto + ": " + (ctiTextoFiltroUts !== "" ? ctiTextoFiltroUts : Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"), //selectedTipoGenerica.ctiTexto + ": " + ( selectedTipoGenerica.ctiTextoCalculadoFiltroUts!= null && Object.keys(genericaSistema.uts).includes(selectedTipoGenerica.campoCtiTexto) ?  genericaSistema.uts[selectedTipoGenerica.campoCtiTexto] :  Object.keys(genericaSistema.uts).includes("ctiTexto") ? genericaSistema.uts['ctiTexto'] : "NO ENCONTRADO"  ),

                // estos aún tiene mejora
            }

            let nameEventPadre = (props.codMenu + "-" + operaciontgRef.id + "-" + newSelectedTipoGenerica.ctiTextoFiltroUts).toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(" ", "_");


            console.log("genericaSistema.uts, ", genericaSistema.uts, "lista nueva, ", newSelectedTipoGenerica);

            let eventPadre = {
                item: {
                    idEmpresa: idEmpresa, idioma: idioma, name: nameEventPadre, codMenu: props.codMenu, level: props.level + 1,
                    selectedTipoGenerica: newSelectedTipoGenerica, label: operaciontgRef.ctiTextotgRef
                }
            }

            //s let bodyContentPayload = { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg, 'filtroUts': filtroUts };

            let contentPayload = JSON.stringify(eventPadre);
            let hash = crypto.SHA512(contentPayload + userName + userName).toString()

            let contentPayloadEnveloped = { hash: hash, bodyContentPayload: eventPadre }

            contentPayload = JSON.stringify(contentPayloadEnveloped);

            let payloadEncoded = Buffer.from(contentPayload).toString('base64');

            //Buffer.from(str, 'base64') andbuf.toString('base64')

            //const myJSONStr = JSON.stringify(payloadEncoded);

            console.log("viewReport");
            window.open('../report?payload=' + payloadEncoded, '_blank', 'noreferrer');

            //props.addSubTabMenu(eventPadre);

        }

        else {

        }

    }

    const confirmdeleteGenericaSistema = (genericaSistema) => {
        setGenericaFormulario(genericaSistema);
        setDeletegenericaSistemaDialogFormulario(true);
    }

    const deleteGenericaSistema = () => {
        let _genericasSistema = genericasSistema.filter(val => val.id !== genericaFormulario.id);
        setGenericasSistema(_genericasSistema);
        setDeletegenericaSistemaDialogFormulario(false);
        setGenericaFormulario(emptyGenericaSistema);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'genericaSistema Deleted', life: 3000 });
    }

    const findIndexById = (id) => {

        let index = -1;
        for (let i = 0; i < genericasSistema.length; i++) {
            if (genericasSistema[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    /*
    const createId = () => {
        let id = '';
        let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 5; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
    }
    */

    const confirmDeleteSelected = () => {
        setdeletegenericasSistemaDialog(true);
    }

    const cols = [
        { field: 'code', header: 'Code' },
        { field: 'name', header: 'Name' },
        { field: 'category', header: 'Category' },
        { field: 'quantity', header: 'Quantity' }
    ];

    const exportColumns = selectedColumns.filter(et => et.ctiConfigurado >= 0 && et.esImprimible > 0)
        .map((col) => ({ title: col.ctiTexto, dataKey: col.campo }));

    ///columnsDataTable

    const exportPdf = () => {
        genericasSistema.map(x => x.uts)
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);

                doc.autoTable(exportColumns, genericasSistema.map(x => x.uts));
                doc.save('datos.pdf');
            });
        });
    };

    const exportExcel = async () => {

        let tg = selectedTipoGenerica.tg === undefined ? "" : selectedTipoGenerica.tg;

        let filtroUts = {};
        let lazyParamsExport = { ...lazyParams, first: -1, rows: -1, page: -1 };

        if (selectedTipoGenerica.filtroUts !== undefined) {
            for (const campo in selectedTipoGenerica.filtroUts) {
                if (campo.includes("ctiTexto") === false) {
                    filtroUts[`${campo}`] = selectedTipoGenerica.filtroUts[campo];
                }
            }
        }

        genericaSistemaService.getGenericasSistema(tg, { lazyEvent: JSON.stringify(lazyParamsExport) }, idEmpresa, idioma, userName, filtroUts).then(data => {
            //setMetadataGenericaSistema(data.metadata);

            //console.log("exportExcel DATA", data.data);
            //console.log("exportExcel DATA", selectedColumns.filter(et => et.ctiConfigurado >= 0 && (et.esImprimible > 0)));

            let dataExport = data.data.map(x => { let newData = {}; selectedColumns.filter(et => et.ctiConfigurado >= 0 && (et.esImprimible > 0)).forEach(metadata => newData[metadata.ctiTexto] = metadata.tipoDato !== "text" || (metadata.tipoDato === "text" && x.uts[metadata.campo] !== null && x.uts[metadata.campo] !== undefined) ? x.uts[metadata.campo] : ""); return newData });

            //const htmlToRtf = require('html-to-rtf');

            import('xlsx').then(async (xlsx) => {

                const worksheet = xlsx.utils.json_to_sheet(dataExport, { raw: false });

                let metadataRichText = selectedColumns.filter(mt => mt.tipoDato === "text");

                if (metadataRichText.length > 0) {

                    const headers = await get_header_row(worksheet);

                    var range = xlsx.utils.decode_range(worksheet['!ref']);

                    if (range.e.r > 0) {

                        for (var r = range.s.r + 1; r <= range.e.r; r++) {
                            for (var c = range.s.c; c <= range.e.c; c++) {
                                if (metadataRichText.some(x => x.ctiTexto === headers[c].header)) {
                                    var cellName = xlsx.utils.encode_cell({ c: c, r: r });
                                    //worksheet[cellName].r = convertHtmlToRtf(worksheet[cellName].v);
                                    //worksheet[cellName].r = "rtf1";
                                    //delete worksheet[cellName].v
                                }
                            }
                        }
                    }

                }

                const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
                const excelBuffer = xlsx.write(workbook, {
                    bookType: 'xlsx',
                    type: 'array'
                });

                saveAsExcelFile(excelBuffer, 'exports');
            });

        });


    };

    const get_header_row = async (sheet) => {

        var headers = [];
        await import('xlsx').then((xlsx) => {


            var range = xlsx.utils.decode_range(sheet['!ref']);
            var C, R = range.s.r; /* start in the first row */
            /* walk every column in the range */
            for (C = range.s.c; C <= range.e.c; ++C) {
                var cell = sheet[xlsx.utils.encode_cell({ c: C, r: R })] /* find the cell in the first row */

                var hdr = "UNKNOWN " + C; // <-- replace with your desired default 
                if (cell && cell.t) hdr = { header: xlsx.utils.format_cell(cell), c: C, indexC: C };

                headers.push(hdr);
            }


        });

        return headers;


    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

    //<Button icon="pi pi-upload" className="p-button-rounded p-button-secondary mr-1" aria-label='Exportar' tooltip='Exportar' onClick={exportCSV} />

    const leftToolbarTemplate = () => {



        let operacionNew = selectedTipoGenerica.operaciones.find(x => x.tipoOperacion === "NEW");

        //console.log("leftToolbarTemplate, ", operacionNew);

        if (!versionSimplificada) {

            return (
                <div className="my-2">

                    {canExportXLS ? <Button type="button" icon="pi pi-file-excel" severity="success" className="p-button-rounded" onClick={exportExcel} data-pr-tooltip="XLS" /> : <></>}

                    {operacionNew !== undefined ? <Button icon="pi pi-plus" className="p-button-rounded p-button-info mr-1" tooltip='Nuevo' onClick={openNew} label={visibleTextButton ? operacionNew.ctiTexto : ""} /> : <></>}

                    {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "COPY") ? <Button icon="pi pi-copy" className="p-button-rounded p-button-info mr-1" tooltip='Copiar' onClick={copyGenerica} disabled={selectedGenericasSistema === null} /> : <></>}

                    {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "REMOVE") ? <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-1" tooltip='Elminiar' onClick={confirmDeleteSelected} disabled={selectedGenericasSistema === null} /> : <></>}

                    {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "EXPORT_XLS") ? <Button type="button" icon="pi pi-file-excel" severity="success" className="p-button-rounded" onClick={exportExcel} data-pr-tooltip="XLS" /> : <></>}

                    {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "EXPORT_PDF") ? <Button type="button" icon="pi pi-file-pdf" severity="warning" className="p-button-rounded" onClick={exportPdf} data-pr-tooltip="PDF" /> : <></>}

                    <Button icon="pi pi-filter-slash" className="p-button-rounded p-button-secondary mr-1" tooltip="clear filters" onClick={clearFilter1} /> : <></>


                </div>

            );

        }
        else {
            return (
                <div className="my-2">

                    {operacionNew !== undefined ? <Button icon="pi pi-plus" className="p-button-rounded p-button-info mr-1" tooltip='Nuevo' onClick={openNew} label={operacionNew.ctiTexto} /> : <></>}

                    {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "COPY") ? <Button icon="pi pi-copy" className="p-button-rounded p-button-info mr-1" tooltip='Copiar' onClick={copyGenerica} disabled={selectedGenericasSistema === null} /> : <></>}

                    {selectedTipoGenerica.operaciones.some(x => x.tipoOperacion === "REMOVE") ? <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-1" tooltip='Elminiar' onClick={confirmDeleteSelected} disabled={selectedGenericasSistema === null} /> : <></>}

                </div>

            );
        }
    }

    const showOverlayPanel = (e) => {
        overlayPanelRef.current.toggle(e);
        //console.log(op.formRef);
        //op.formRef.visible=true;
    }

    const rightToolbarTemplate = () => {

        return (
            <>
                <Button type="button" icon="pi pi-bars" aria-label='Columas en tabla' onClick={(e) => showOverlayPanel(e)} aria-haspopup aria-controls="overlay_panel" className="select-product-button" />

                <OverlayPanel ref={overlayPanelRef} showCloseIcon style={{ width: '25rem', marginTop: '1rem', marginLeft: '1rem' }} className="overlaypanel-demo">
                    <MultiSelect value={selectedColumns} className="mr-1"
                        options={metadataGenericaSistema.filter(col => col.ctiConfigurado >= 0 && (col.esImprimible > 0))}
                        optionLabel="ctiTexto" onChange={onColumnToggle} style={{ width: '20em' }} />
                </OverlayPanel>
            </>


        )
    }

    const deletegenericaSistemaDialogFormularioFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hidedeletegenericaSistemaDialogFormulario} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteGenericaSistema} />
        </>
    );
    const deletegenericasSistemaDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hidedeletegenericasSistemaDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteSelectedgenericasSistema} />
        </>
    );

    const onSelectionChange = (event) => {
        const value = event.value;
        setSelectedGenericasSistema(value);

        if (props.onSelectionChange)
            props.onSelectionChange(value);
        //setSelectAll(value.length === totalRecords);

    }

    const crearNewEmptyGenerica = (metadata) => {

        let item = {}

        item['id'] = 0;
        item['idEmpresa'] = idEmpresa;
        item['idioma'] = "ES";
        item['tg'] = metadata.length > 0 ? metadata[0].tg : "";

        item['uts'] = {};

        metadata.forEach(x => {
            if (x.campo === "tg")
                item[`${x.campo}`] = x.tg;

            else {

                let newVal = "";
                if (x.tipoDato === "date")
                    newVal = 0;
                else if (x.tipoDato === "int") newVal = 0;
                else if (x.tipoDato === "double") newVal = 0.0;
                else if (x.tipoDato === "money") newVal = 0;
                else if (x.tipoDato === "boolean") newVal = false;
                else newVal = "";

                if (selectedTipoGenerica.filtroUts !== undefined) {

                    if (selectedTipoGenerica.filtroUts[x.campo] !== undefined && selectedTipoGenerica.filtroUts[x.campo] !== "") {
                        newVal = selectedTipoGenerica.filtroUts[x.campo];
                        item['uts'][`${x.campo}`] = newVal
                    }


                    //console.log("newVal,", x.campo,newVal);
                    //console.log("selectedTipoGenerica,", selectedTipoGenerica);
                }



                //item['uts'] = { ...item['uts'], [`${x.campo}`]: newVal }

            }
        });

        return item;

    }

    useEffect(() => {

        if (lazyParams !== undefined && selectedTipoGenerica !== undefined) {
            setSelectedGenericasSistema(null);
            loadLazyData();
        }

    }, [lazyParams]) // eslint-disable-line react-hooks/exhaustive-deps

    const loadLazyData = () => {
        setLoading(true);

        //if (loadLazyTimeout) {
        //clearTimeout(loadLazyTimeout);
        //}

        let tg = selectedTipoGenerica.tg === undefined ? "" : selectedTipoGenerica.tg;

        let filtroUts = {};
        let _filtroUtsValido = true;
        let _mensajeFiltroUtsValido = "";

        if (selectedTipoGenerica.filtroUts !== undefined) {
            for (const campo in selectedTipoGenerica.filtroUts) {
                if (campo.includes("ctiTexto") === false) {
                    filtroUts[`${campo}`] = selectedTipoGenerica.filtroUts[campo];
                    if (selectedTipoGenerica.filtroUts[campo] === null || selectedTipoGenerica.filtroUts[campo] === undefined) {
                        _filtroUtsValido = false;
                        let campoInvalido = metadataGenericaSistema.find(x => x.tg === selectedTipoGenerica.tg && x.campo === campo);
                        _mensajeFiltroUtsValido = _mensajeFiltroUtsValido + ", " + campoInvalido.ctiTexto;
                    }

                }
            }
        }

        setFiltroUtsValido(_filtroUtsValido);

        if (!_filtroUtsValido) {

            _mensajeFiltroUtsValido = _mensajeFiltroUtsValido.substring(2, _mensajeFiltroUtsValido.length);

            setMensajeFiltroUtsValido("Debe seleccionar los siguientes campos en las tablas de arriba -> " + _mensajeFiltroUtsValido);

            setGenericasSistema([]);
            setTotalRecords(0);
            setLoading(false);
            setComodin(prev => prev + 1);


        }
        else {

            genericaSistemaService.getGenericasSistema(tg, { lazyEvent: JSON.stringify(lazyParams) }, idEmpresa, idioma, userName, filtroUts).then(data => {
                //setMetadataGenericaSistema(data.metadata);


                if (selectedTipoGenerica.tipoTabla == "10" && data.metadata.length > 0 && ((metadataGenericaSistema.find(x => x.idTipoAtributo >= 999) === undefined) && (data.metadata.find(x => x.idTipoAtributo >= 999) !== undefined))) {
                    //if ( selectedTipoGenerica.tipoTabla =="10" && data.metadata.length>0 && (( metadataGenericaSistema.length===0) || ( metadataGenericaSistema.length>0 && data.metadata[0].tg !== metadataGenericaSistema[0].tg )) ){

                    let dataRef = data.metadata.map(x => ({ campo: x.campo, tipoDato: x.tipoDato, tg: x.tg, columnFiltroRef: null }));

                    let _metadataGenericaSistemaTgOperaciones = data.metadata;
                    let newSelectedColumns = data.metadata;//metadataImprimible.filter(col => col.campo !== columnaIdentificadorOculta)
                    let dataForm = newSelectedColumns;

                    if (dataRef.length > 0) {

                        setSelectedColumns([]);

                        setEmptyGenericaSistema(crearNewEmptyGenerica(dataForm));

                        lazyParamInit.filters = createHeaderGenerica(dataForm);
                        let newLazyParamInit = Object.assign({}, lazyParamInit);
                        //console.log("lazyParamInit, ", lazyParamInit);

                        setMetadataGenericaSistema(data.metadata);

                        setMetadataGenericaSistemaRef(dataRef);
                        setMetadataGenericaFormulario(dataForm);
                        setMetadataGenericaFormularioFactura(dataForm);

                        setSelectedTipoGenericaFormulario(selectedTipoGenerica);
                        setSelectedTipoGenericaFormularioFactura(selectedTipoGenerica);

                        setLazyParams({ ...newLazyParamInit });
                        lazyParamsInitSelected.current = newLazyParamInit;
                        setSelectedColumns(newSelectedColumns);

                        if (selectedTipoGenerica.operaciones)
                            setCanEditRow(selectedTipoGenerica.operaciones === undefined ? false : selectedTipoGenerica.operaciones.some(x => x.tg === selectedTipoGenerica.tg && x.tipoOperacion === "EDIT_ROW"));

                        setMetadataGenericaSistemaTgOperaciones(_metadataGenericaSistemaTgOperaciones);
                        setGenericaFormulario(emptyGenericaSistema);
                        setGenericaFormularioFactura(emptyGenericaSistema);



                    }
                }

                if (props.onDataLoaded) {
                    props.onDataLoaded(data.data);
                }

                setGenericasSistema(data.data)
                setTotalRecords(previo => previo < 0 ? data.totalRecord : data.totalRecord);
                setLoading(false);
                setComodin(prev => prev + 1);

                if (data.data.length === 1 && props.accionAutomaticaConRegistroUnico) {

                }

            });

        }

    }

    const onPage = (event) => {
        setLazyParams(event);
    }

    const onSort = (event) => {
        setLazyParams(event);
    }

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    }

    /*
    const onSelectAllChange = (event) => {
        const selectAll = event.checked;

        if (selectAll) {
            genericaSistemaService.getGenericasSistema(selectedTipoGenerica.tg).then(data => {
                setSelectAll(true);
                setSelectedGenericasSistema(data.genericas);
            });
        }
        else {
            setSelectAll(false);
            setSelectedGenericasSistema([]);
        }
    }

    */

    //<InputNumber value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} mode="currency" currency="USD" locale="en-US" />
    const ColumnFilterTemplate = (options) => {


        //const campo =  selectedColumns.find(et => et.campo ===options.field);
        //const metadataRef =  metadataGenericaSistemaRef.find(et => et.campo ===options.field);
        const metadata = metadataGenericaSistema.find(et => et.campo === options.field);
        const metaColumn = selectedColumns.find(et => et.campo === options.field);

        //const lazyParamCampo = Object.keys(lazyParams.filters).includes(options.field) ? lazyParams.filters[`${metadata.campo}`] : null;
        //const val = lazyParamCampo !== null ? lazyParamCampo.value : "";

        switch (metadata.tipoDato) {
            case "boolean": return <TriStateCheckbox id={`filter${metadata.tg + '-' + metadata.campo}`} value={options.value} onChange={(e) => { console.log("cambio boolean", e); onfilterapply(options, e) }} />;
            case "int": return (<InputNumber id={`filter${metadata.tg + '-' + metadata.campo}`} placeholder="Search..." style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e)} />);
            case "double": return (<InputNumber id={`filter${metadata.tg + '-' + metadata.campo}`} placeholder="Search..." mode="decimal" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e)} />);
            case "money": return (<InputNumber id={`filter${metadata.tg + '-' + metadata.campo}`} placeholder="Search..." mode="currency" currency="COP" locale="es-CO" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onValueChange={(e) => onfilterapply(options, e)} />);
            default: return (<InputText id={`filter${metadata.tg + '-' + metadata.campo}`} ref={e => metaColumn.columnRef = e} placeholder="Search..." type="search" style={{ paddingLeft: '0.5rem', minWidth: '5rem', maxWidth: '10rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} />);
        }

        //return <TriStateCheckbox id ={`filter${metadataRef.campo+metadataRef.tg}`} ref={e => metadataRef.columnFiltroRef = e} value={options.value} onChange={(e) => options.filterCallback(e.value)}   />

        //if (metadataRef=== undefined)
        //return (<InputText id ={`filter${options.field}`} type="search" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} placeholder="Search..." />)
        //else
        //return (<InputText id ={`filter${metadataRef.campo+metadataRef.tg}`} ref={e => metadataRef.columnFiltroRef = e} type="search" style={{ paddingLeft: '0.5rem', 'minWidth': '5rem' }} onKeyDown={(e) => { if (e.key === 'Enter') { onfilterapply(options, e) } }} placeholder="Search..." />)

    }

    const onfilterapply = (options, event) => {
        options.filterApplyCallback(event.target.value);
        setSelectedGenericasSistema(undefined);
        if (props.onSelectionChange)
            props.onSelectionChange(undefined);

    }

    const cardBodyTemplate = (rowData) => {

        if (rowData.tg === "BPM_VSTA_SOLICITUD_CD_ASESOR_DATO_PERSONAL") {
            console.log("rowData", rowData, "filter, ", selectedColumns.filter(et => et.ctiConfigurado >= 0 && (et.esImprimible > 0) && et.tipoDato !== "ref"));
        }

        return selectedColumns.filter(et => et.ctiConfigurado >= 0 && (et.esImprimible > 0) && et.tipoDato !== "ref").map(k => {

            let column = { field: k.campo }
            let metadata = k;

            let classNameFlex = "flex-1 md:flex-none";
            switch (metadata.tipoDato) {
                case "boolean":
                    classNameFlex = metadata.formatoDato !== "aceptaTerminos" ? "col-12 md:col-3 lg:col-2" : "col-12";
                    break;
                case "ref": classNameFlex = "col-6 md:col-3 lg:col-2"; break;
                case "text": classNameFlex = "col-12"; break;
                default: classNameFlex = "col-6 md:col-3 lg:col-2";
            }

            console.log("k.formatoDato, ", k.campo, k.tipoDato, k.formatoDato);
            return (<>
                <div className={classNameFlex}>
                    <label className='flex align-items-start font-semibold' id={`label${metadata.tg}-${metadata.campo}`}>{metadata.ctiTexto}  </label>
                    <div className='flex lg:align-items-start'>
                        {
                            (function () {



                                switch (k.tipoDato) {
                                    case 'boolean':
                                        return booleanBodyTemplate(rowData, column);

                                    case 'double':
                                        return doubleBodyTemplate(rowData, column);
                                    case 'int':
                                        k.formatoDato === "money" ? moneyBodyTemplate(rowData, column) : intBodyTemplate(rowData, column)
                                    case 'money':
                                        return moneyBodyTemplate(rowData, column);
                                    case 'tags':
                                        return tagsBodyTemplate(rowData, column);
                                    case 'text':
                                        return textRichBodyTemplate(rowData, column);
                                    case 'date':
                                        return dateBodyTemplate(rowData, column);
                                    case 'color':
                                        return colorBodyTemplate(rowData, column);
                                    case 'file':
                                        return fileBodyTemplate(rowData, column);

                                    default:
                                        {
                                            if (k.tipoDato === 'ref' && k.formatoDato === 'ACA_UNIDAD_RA_CRITERIO_NIVEL') return selectButtonBodyTemplate(rowData, column)
                                            else
                                                return textBodyTemplate(rowData, column);
                                        }
                                }

                            })()
                        }
                    </div>
                </div>

            </>)


        });

    }

    const columnBodyTemplate = (tipoDato, formatoDato) => {
        if (selectedTipoGenerica.tg === "11ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA_RA" && formatoDato === "ACA_UNIDAD_RA_CRITERIO_NIVEL") {
            return selectButtonBodyTemplate;
        }

        switch (tipoDato) {
            case 'boolean':
                return booleanBodyTemplate

            case 'double':
                return doubleBodyTemplate
            case 'int':
                return formatoDato === "money" ? moneyBodyTemplate : intBodyTemplate
            case 'money':
                return moneyBodyTemplate
            case 'tags':
                return tagsBodyTemplate
            case 'text':
                return textRichBodyTemplate
            case 'date':
                return dateBodyTemplate
            case 'color':
                return colorBodyTemplate
            case 'file':
                return fileBodyTemplate
            default:
                {
                    if (tipoDato === 'ref' && formatoDato === 'ACA_UNIDAD_RA_CRITERIO_NIVEL') return selectButtonBodyTemplate;
                    else
                        return textBodyTemplate;
                }
        }
    }

    const selectedOptionBodyTemplate2 = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === "ctiTexto" + column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }
        if (val === "" || val === null)
            val = "Pendiente";

        return <span >{val}</span>;

    }

    const colorBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = "";
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <ColorPicker disabled value={val} />;
    }

    function isValidColor(strColor) {
        var s = new Option().style;
        s.color = strColor;

        // return 'false' if color wasn't assigned
        return s.color === strColor.toLowerCase();
    }

    const tagsBodyTemplate = (rowData, column) => {

        let tagsString = rowData.uts[column.field];

        if (tagsString !== undefined && tagsString !== "") {

            let tags = JSON.parse('' + tagsString + '');

            if (tags !== null) {
                return (



                    tags.map(x =>
                        <Tag key={rowData.id} rounded style={{ backgroundColor: isValidColor(x.color) ? x.color : "#" + x.color }} value={x.ctiTexto}>
                        </Tag>

                    )




                );

            }
            else {
                return (<></>);
            }



        }
        else
            return (<></>);


    }

    const booleanBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = (typeof rowData.uts[column.field] === "boolean") ? rowData.uts[column.field] : typeof rowData.uts[column.field] === "string" ? rowData.uts[column.field].toLowerCase() === "true" : false;
        }

        if (val === true) {
            return (<i className={classNames('pi', val === true ? 'true-icon pi-check-circle' : 'false-icon pi-times-circle')} style={{ color: 'green' }} ></i>);
        }
        else {
            return (<i className={classNames('pi', val === true ? 'true-icon pi-check-circle' : 'false-icon pi-times-circle')} style={{ color: 'red' }} ></i>);
        }

        //return (<Checkbox checked={val} readOnly className='surface-300' ></Checkbox>);
    }

    const doubleBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = 0.00;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toFixed(2)}</span>;
    }

    const intBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = 0;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{Math.trunc(val)}</span>;
    }

    const moneyBodyTemplate = (rowData, column) => {
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = false;
        if (metadata) {
            val = rowData.uts[column.field];
        }

        return <span >{val.toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}</span>;
    }

    const textBodyTemplate = (rowData, column) => {

        let val = "";
        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        if (metadata) {
            val = rowData.uts[column.field];
        }

        let valTexto = "";
        if (metadata) {
            valTexto = rowData.uts[column.field];
        }
        let tamMaximoVisibleFila = 80;
        let mostrarBoton = (valTexto !== undefined && valTexto !== null && valTexto !== "" && valTexto.length > tamMaximoVisibleFila);
        val = mostrarBoton ? valTexto.substring(0, tamMaximoVisibleFila) + "[...]" : valTexto;

        let esValido = !validaData ? true : (!metadata.esRequerido ? true : (val !== "" && val !== undefined && val !== null));

        if (!esValido) {

            return (<div className='p-invalid-cell '> <i className="pi pi-times-circle" style={{ color: "red" }}></i> &nbsp;</div>);

        }
        else {
            return (
                <>
                    {
                        (function () {
                            //rounded text raised                         
                            if (mostrarBoton) return <Button style={{ width: '2rem', height: '2rem' }} size="small" icon="pi pi-external-link" className="p-button-rounded" aria-label="Ver más" onClick={() => { setDialogText(valTexto); setDialogTextVisible(true); }} />
                        })()
                    }

                    <div style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: val }} />


                </>
            );
        }
        //<span style={{ maxWidth: "5rem", wordBreak: "break-word" }} >{val}</span>
    }

    const textRichBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let valTexto = "";
        if (metadata) {
            valTexto = rowData.uts[column.field];
        }
        let tamMaximoVisibleFila = 80;
        let mostrarBoton = (valTexto !== undefined && valTexto !== null && valTexto !== "" && valTexto.length > tamMaximoVisibleFila);
        let val = mostrarBoton ? valTexto.substring(0, tamMaximoVisibleFila) + "[...]" : valTexto;

        return (
            <>
                {
                    (function () {
                        //rounded text raised
                        if (mostrarBoton) return <Button style={{ width: '2rem', height: '2rem' }} size="small" icon="pi pi-external-link" className="p-button-rounded" aria-label="Ver más" onClick={() => { setDialogText(valTexto); setDialogTextVisible(true); }} />
                    })()
                }

                <div style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: val }} />



            </>
        );
    }

    const fileBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let valRefDoc = "";
        if (metadata) {
            valRefDoc = rowData.uts[column.field];
        }

        if ((valRefDoc !== null && valRefDoc !== undefined && valRefDoc !== ""))
            return (<Link target="_blank" icon="pi pi-download" rel="noopener noreferrer" href={"../file?guid=" + valRefDoc}>Archivo</Link>);
        else
            return <span>No presenta adjunto</span>
    }

    const dateBodyTemplate = (rowData, column) => {

        let metadata = metadataGenericaSistema.find(x => x.campo === column.field);
        let val = "";
        if (metadata) {
            val = rowData.uts[column.field];
        }

        if (metadata.formatoDato === "date") {
            return <span >{val.toLocaleDateString()}</span>;
        }
        else {
            return <span >{val.toLocaleDateString() + " " + val.toLocaleTimeString()}</span>;
        }

    }

    const selectButtonBodyTemplate = (rowData, column) => {
        let items = [];

        //console.log("selectButtonBodyTemplate");

        let campoCtiTextocriterio = 'ctiTextonivelCriterioRA';
        let campoOptionsSelectButton = 'nivelCriterioRA';
        let campoCtiTextoOptionsSelectButton = 'ctiTextonivelDesempeñoRA';

        let campoCriterio = 'criterioRA';
        let valCriterio = rowData.uts[campoCriterio];

        let valBase = rowData.uts[column.field];

        //items = optionsSelectButton.filter(x => x.tg === "ACA_UNIDAD_RA_CRITERIO_NIVEL" && x.uts['criterioRA'] === criterioRA).map(x => ({ value: x.uts[''], 'name': x.uts['ctiTextonivelDesempenoRA'] }));
        items = optionsSelectButton.filter(x => x.tg === "ACA_VSTA_MATRICULADOS_NIVELES_DESEPEÑO_PARA_DIGITACION_NOTA_RA"
            && x.uts[campoCriterio] === valCriterio).map(x => ({ value: x.uts[campoOptionsSelectButton] + '', 'name': x.uts[campoCtiTextoOptionsSelectButton] }));

        //console.log("valBase, ", valBase);
        //console.log("optionsSelectButton, ", optionsSelectButton);
        //console.log("items, ", items);

        return (
            <SelectButton value={valBase} optionLabel="name" options={items} readOnly={true} />
        );

    };

    const ConvertTipoDatoADateTypeTabla = (tipoDato) => {

        let res = "text";

        switch (tipoDato) {
            case "date": res = "date"; break;
            case "int": res = "numeric"; break;
            case "double": res = "numeric"; break;
            case "money": res = "numeric"; break;
            case "boolean": res = "boolean"; break;
            default: res = "text"; break;
        }

        return res;
    }

    const defaultFilterMatchMode = (tipoDato) => {

        let res = undefined;

        switch (tipoDato) {
            case "date": res = FilterMatchMode.EQUALS; break;
            case "int": res = FilterMatchMode.EQUALS; break;
            case "double": res = FilterMatchMode.EQUALS; break;
            case "money": res = FilterMatchMode.EQUALS; break;
            case "boolean": res = FilterMatchMode.EQUALS;
            default: res = FilterMatchMode.CONTAINS; break;
        }

        return res;
    }

    const cellEditor = (options) => {

        console.log("cellEditor, ", options);
        let metadata = metadataGenericaSistema.find(x => x.campo === options.field)

        if (metadata.tipoDato === 'int') return intEditor(options);
        else if (metadata.tipoDato === 'double') return doubleEditor(options);
        else if (metadata.tipoDato === 'money') return moneyEditor(options);
        else if (metadata.tipoDato === 'date') return dateEditor(options);
        else if (metadata.tipoDato === 'boolean') return booleanEditor(options);
        else if (metadata.tipoDato === 'ref' && metadata.formatoDato === 'ACA_UNIDAD_RA_CRITERIO_NIVEL') return selectButtonEditor(options);
        else return textEditor(options);
    };

    const selectButtonEditor = (options) => {
        let items = [
            { name: 'Option 1', value: 1 }
        ];

        let campoCtiTextocriterio = 'ctiTextocriterioRA';
        let campoOptionsSelectButton = 'nivelDesempeñoRA';
        let campoCtiTextoOptionsSelectButton = 'ctiTextonivelDesempeñoRA';

        let campoCriterio = 'criterioRA';
        let valCriterio = options.rowData.uts[campoCriterio];

        let valBase = options.value !== undefined ? options.value : options.rowData.uts[options.field];

        //items = optionsSelectButton.filter(x => x.tg === "ACA_UNIDAD_RA_CRITERIO_NIVEL" && x.uts['criterioRA'] === criterioRA).map(x => ({ value: x.uts[''], 'name': x.uts['ctiTextonivelDesempenoRA'] }));
        items = optionsSelectButton.filter(x => x.tg === "ACA_UNIDAD_RA_CRITERIO_NIVEL" && x.uts[campoCriterio] === valCriterio).map(x => ({ value: x.uts[campoOptionsSelectButton], 'name': x.uts[campoCtiTextoOptionsSelectButton] }));

        console.log("valBase, ", valBase);
        console.log("options, ", options);
        //console.log("optionsSelectButton, ", optionsSelectButton);
        //console.log("items, ", items);

        return (
            <SelectButton value={valBase} optionLabel="name" onChange={(e) => { console.log("ChangeSelectButton,", e.value); if (e.value !== null) options.editorCallback(e.value) }} options={items} />
        );

    };

    const dateEditor = (options) => {
        return <Calendar value={options.value || options.rowData.uts[options.field]} showButtonBar yearNavigator={false} showIcon dateFormat="dd/mm/yy" onChange={(e) => { if (e.value !== null) options.editorCallback(e.value) }} />;
    };

    const moneyEditor = (options) => {
        return <InputNumber value={options.value || options.rowData.uts[options.field]} onValueChange={(e) => { if (e.value !== null) options.editorCallback(e.value); }} />;
    };

    const booleanEditor = (options) => {
        console.log("options, ", options, "options.rowData.uts[options.field], ", options.rowData.uts[options.field]);
        let valBase = options.value !== undefined ? options.value : options.rowData.uts[options.field];
        let val = typeof valBase === "boolean" ? valBase : typeof valBase === "string" ? valBase.toLowerCase() === "true" : false;

        //return <InputNumber value={options.value} onValueChange={(e) => { if (e.value !== null) options.editorCallback(e.value); }} mode="currency" currency="COP" locale="es-CO" />;
        return <Checkbox checked={val} onChange={(e) => { console.log("evento, ", e); if (e.checked !== null) options.editorCallback(e.checked); }}  ></Checkbox>
    };

    const intEditor = (options) => {
        return <InputNumber value={options.value || options.rowData.uts[options.field]} onValueChange={(e) => { if (e.value !== null) options.editorCallback(e.value) }} />;
    };

    const doubleEditor = (options) => {
        return <InputNumber value={options.value || options.rowData.uts[options.field]} mode="decimal" onValueChange={(e) => { if (e.value !== null) options.editorCallback(e.value) }} />;
    };

    const textEditor = (options) => {
        return <InputText type="text" value={options.value || options.rowData.uts[options.field]} onChange={(e) => { if (e.target.value !== null) options.editorCallback(e.target.value) }} />;
    };

    /*const isPositiveInteger = (val) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };
    */

    const onCellEditComplete = async (e) => {

        let { rowData, newValue, field, originalEvent: event } = e;

        console.log("onCellEditComplete", e);
        // validaciones varias que aún están programadas.

        setSubmitted(true);
        setLoading(true);

        if (newValue !== undefined && rowData.uts[field] !== newValue) {

            //[field] = newValue;

            let tgRefOps = selectedTipoGenerica.operacionesCampos.find(x => x.tipoOperacion === "EDIT_ROW")

            let genericaSistema = { id: rowData.id, idEmpresa: idEmpresa, idioma: idioma, tg: tgRefOps.tgRef, uts: {} }

            let itemOpsCampo = {};

            for (let i = 0; i < selectedTipoGenerica.operacionesCampos.length; i++) {
                itemOpsCampo = selectedTipoGenerica.operacionesCampos[i];
                if (itemOpsCampo.id === tgRefOps.id) {

                    if (itemOpsCampo.campotg === field)
                        genericaSistema.uts[itemOpsCampo.campotgRef] = newValue;
                    else
                        genericaSistema.uts[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

                }
            }

            //genericaSistema[itemOpsCampo.campotgRef] = rowData.uts[itemOpsCampo.campotg];

            console.log("sende, ", genericaSistema);

            await genericaSistemaService.saveGenericaSistema(idEmpresa, idioma, userName, genericaSistema).then(response => {

                console.log("response, ", response);

                let genericaSistemaAffect = response.genericasSistemaAffected.find(x => x.tg === selectedTipoGenerica.tg);

                if (selectedTipoGenerica.tg === genericaSistemaAffect.tg) {

                    if (response.mensaje === "") {

                        if (props.onSaveSuccessfull) { props.onSaveSuccessfull(response.genericasSistemaAffected); }

                        if (rowData.id > 0) {
                            //rowData.uts[field] = newValue;
                            rowData.uts = genericaSistemaAffect.uts;
                        }
                        else {
                            rowData.id = genericaSistemaAffect.id;
                            rowData.cti = genericaSistemaAffect.cti;
                            //rowData.uts[field] = newValue;
                            rowData.uts = genericaSistemaAffect.uts;

                        }

                        const index = findIndexById(rowData.id);
                        let _genericasSistema = [...genericasSistema];

                        let newGen = { ...genericasSistema[index] };

                        newGen.id = response.id;
                        newGen.cti = response.cti;
                        newGen.uts = { ...genericaSistemaAffect.uts };
                        newGen.uts["secUuid"] = window.crypto.randomUUID();

                        if (response.campoSequenceTg !== "")
                            newGen.uts[response.campoSequenceTg] = response.sequenceTg;

                        _genericasSistema[index] = newGen;

                        setGenericasSistema(_genericasSistema);

                        //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                        //_genericasSistema.unshift(_genericaSistema);





                        //setGenericaSistemaDialogFormulario(false);
                        //setGenericaSistema(crearNewEmptyGenerica(metadataGenericaSistemaForm));
                    }
                    else {

                        if (rowData.id > 0) {
                            rowData.uts[field] = newValue;
                            //rowData.uts  = genericaSistemaAffect.uts;
                        }
                        else {
                            rowData.id = response.id;
                            rowData.cti = response.cti;
                            if (response.campoSequenceTg !== "")
                                rowData.uts[response.campoSequenceTg] = response.sequenceTg;
                            rowData.uts[field] = newValue;

                            /*const index = findIndexById(rowData.id);
                            let _genericasSistema = [...genericasSistema]
    
                            _genericasSistema[index].id = response.id;
                            _genericasSistema[index].cti = response.cti;
                            if (response.campoSequenceTg!=="")
                            _genericasSistema[index].uts[response.campoSequenceTg] = response.sequenceTg;
    
                            setGenericasSistema(_genericasSistema);*/

                            //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                            //_genericasSistema.unshift(_genericaSistema);
                        }

                    }

                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });

                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error Message', detail: response.mensaje });
                }

            });

            /*
            switch (field) {
                case 'quantity':
                case 'price':
                    if (isPositiveInteger(newValue)) rowData.uts[field] = newValue;
                    else event.preventDefault();
                    break;

                default:
                    if (newValue.trim().length > 0) rowData.uts[field] = newValue;
                    else event.preventDefault();
                    break;
            }*/

        }

        setLoading(false);

        if (props.onChangeDataInterno) {

            if (selectedTipoGenerica.tg === "ACA_VSTA_MATRICULADOS_DETALLE_PARA_DIGITACION_NOTA") {
                //genericasSistema.forEach(x=>)

            }

        }

    };


    //return <Column key={k.campo}  field={k.campo} header={ k.ctiTexto } sortable filter filterPlaceholder="Buscar por xyz" />;
    const columnsDataTable = selectedColumns.filter(et => et.ctiConfigurado >= 0 && (et.esImprimible > 0)).map(k => {

        //console.log("conColumnFilter, ", conColumnFilter, k.campo, canEditRow, k.actualizableEnTabla);

        if (k.actualizableEnTabla) {

            return <Column key={k.campo} field={k.campo} header={k.ctiTexto} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)} filterMatchMode={defaultFilterMatchMode(k.tipoDato)}
                body={columnBodyTemplate(k.tipoDato, k.formatoDato)} sortable
                //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
                filter filterElement={ColumnFilterTemplate}
                filterPlaceholder="Buscar por xyz"
                editor={(options) => {
                    if (canEditRow) {
                        return cellEditor(options)
                    }
                    else return null;
                }}
                cellEditValidator={(options) => true}
                onCellEditComplete={canEditRow ? onCellEditComplete : null}
            />;

        }
        else {

            return <Column key={k.campo} field={k.campo} header={k.ctiTexto} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
                filterMatchMode={defaultFilterMatchMode(k.tipoDato)}
                body={columnBodyTemplate(k.tipoDato, k.formatoDato)} sortable
                //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
                filter={conColumnFilter} filterElement={ColumnFilterTemplate}
                filterPlaceholder="Buscar por xyz"
            />;
        }

    });

    const columnsCard = () => {
        selectedColumns.filter(et => et.ctiConfigurado >= 0 && (et.esImprimible > 0)).map(k => {

            console.log("conColumnFilter, ", conColumnFilter);

            if (k.actualizableEnTabla) {

                return <Column key={k.campo} field={k.campo} header={k.ctiTexto} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)} filterMatchMode={defaultFilterMatchMode(k.tipoDato)}
                    body={columnBodyTemplate(k.tipoDato, k.formatoDato)} sortable
                    //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
                    filter filterElement={ColumnFilterTemplate}
                    filterPlaceholder="Buscar por xyz"
                    editor={canEditRow ? (options) => cellEditor(options) : null} onCellEditComplete={canEditRow ? onCellEditComplete : null}
                />;

            }
            else {

                return <Column key={k.campo} field={k.campo} header={k.ctiTexto} dataType={ConvertTipoDatoADateTypeTabla(k.tipoDato)}
                    filterMatchMode={defaultFilterMatchMode(k.tipoDato)}
                    body={columnBodyTemplate(k.tipoDato, k.formatoDato)} sortable
                    //filter filterElement={k.tipoDato === "boolean" ? booleanRowFilterTemplate : textRowFilterTemplate} 
                    filter={conColumnFilter} filterElement={ColumnFilterTemplate}
                    filterPlaceholder="Buscar por xyz"
                />;
            }

        });

    }


    const clearFilter1 = () => {
        initFilters1();
    }

    const onColumnToggle = (event) => {

        let newselectedColumns = event.value;

        let orderedSelectedColumns = metadataGenericaSistema.filter(col => newselectedColumns.some(sCol => sCol.campo === col.campo && col.ctiConfigurado >= 0 && (col.esImprimible > 0)));

        setSelectedColumns(orderedSelectedColumns);
    }

    Toolbar

    const toolbar = () => {

        let muestraToolbar = props.muestraToolbar === undefined || props.muestraToolbar

        if (muestraToolbar) {
            return (<Toolbar className="mb-1" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>);
        }
        else {
            return (<></>);
        }

    }


    const header = () => {

        let muestraCabecera = props.muestraCabecera === undefined || props.muestraCabecera

        if (muestraCabecera) {

            if (selectedTipoGenerica !== undefined) {
                //GetTextoEtiqueta("LABEL_MANAGE") + " - " +
                return (<div className="">
                    <h5 className="m-0">{selectedTipoGenerica.ctiTextoFiltroUts !== null && selectedTipoGenerica.ctiTextoFiltroUts !== undefined
                        && selectedTipoGenerica.ctiTextoFiltroUts !== "" ? selectedTipoGenerica.ctiTextoFiltroUts : selectedTipoGenerica.ctiTexto}</h5>
                    {
                        (function () {
                            //rounded text raised                         
                            if (!filtroUtsValido) return (<span style={{ color: "red" }}>{mensajeFiltroUtsValido}</span>);
                        })()
                    }

                    <br></br>
                    {toolbar()}


                </div>)
            }
            else {
                return (<div className="">
                    {toolbar()}

                </div>)
            }

        }
        else
            return undefined

    }

    /*
        const header2 = (
            <div className="">
    
                <h5 className="m-0">{ selectedTipoGenerica.ctiTextoFiltroUts !== null && selectedTipoGenerica.ctiTextoFiltroUts !== undefined && selectedTipoGenerica.ctiTextoFiltroUts !== ""? selectedTipoGenerica.ctiTextoFiltroUts : GetTextoEtiqueta("LABEL_MANAGE") + " - " + selectedTipoGenerica.ctiTexto}</h5>
                <br></br>
                <Toolbar className="mb-1" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
    
            </div>
    
        );*/

    const createHeaderGenerica = (objecto) => {

        let headers = "";

        //Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&')

        objecto.forEach(function (meta, indice, array) {
            if (indice > 0) {
                headers += ',';
            }
            else {
                headers += '{';
            }

            switch (meta.tipoDato) {
                case "int": headers += `"${meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "double": headers += `"${meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "money": headers += `"${meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "date": headers += `"${meta.campo}":{ "value": "", "matchMode": "equals", "ref": null }`; break;
                case "string": headers += `"${meta.campo}":{ "value": "", "matchMode": "contains", "ref": null }`; break;
                default: headers += `"${meta.campo}":{ "value": "", "matchMode": "contains","ref": null }`; break;
            }

        });

        headers += '}';



        return (JSON.parse('' + headers + ''));
    }


    const initFilters1 = () => {
        setLazyParams(Object.assign({}, lazyParamsInitSelected.current));
        setComodin((prev) => prev + 1);
        //setGlobalFilterValue2('');
    }

    const buscarFilter1 = () => {
        setLazyParams(Object.assign({}, lazyParams));
        //setGlobalFilterValue2('');
    }

    const arrayTemplate = [{}, {}, {}, {}, {}, {}];
    const bodyTemplate = () => {
        return <Skeleton></Skeleton>
    }


    const onSaveSuccessfulFormulario = (_genericaSistema, idOriginal, genericasSistemaAffect) => {

        console.log("sssss, ", idOriginal, genericasSistemaAffect);
        setSubmitted(true);

        let _genericasSistema = [...genericasSistema];

        genericasSistemaAffect.forEach(genericaSistemaAffect => {

            //if (selectedTipoGenerica.tg === genericaSistemaAffect.tg) {
            if (1 == 0) {
                if (idOriginal > 0) {

                    const index = findIndexById(genericaFormulario.id);

                    _genericasSistema[index].uts = genericaSistemaAffect.uts;

                    /*var newLazyParam = Object.assign({}, lazyParams);
                    newLazyParam.iteracion = newLazyParam.iteracion+1;
                    
                    setLazyParams(newLazyParam);
                    */


                }
                else {
                    //console.log("unshift, ",_genericaSistema);
                    //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                    _genericasSistema.unshift(genericaSistemaAffect || _genericaSistema);

                }

                setGenericasSistema(_genericasSistema);

            }
            else {
                /*
                if (idOriginal > 0) {
    
                    const index = findIndexById(idtgAffect);
    
                    if (valuesAffected.length > 0) {
                        for (let campo in valuesAffected) {
                            _genericasSistema[index][campo] = valuesAffected[campo];
                        }
    
                    }
    
                }
                else {
                    //console.log("unshift, ",_genericaSistema);
                    //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                    _genericasSistema.unshift(_genericaSistema);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });
                }*/

                setLazyParams({ ...lazyParams });

            }

        });

        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });

        if (props.onSaveSuccessfull) { props.onSaveSuccessfull(genericasSistemaAffect); }

        setGenericaSistemaDialogFormulario(false);
        setGenericaFormulario(crearNewEmptyGenerica(metadataGenericaFormulario));

    }

    const onSaveSuccessfulFormularioFactura = (_genericaSistema, idOriginal, idtgAffect, tgAffect, valuesAffected) => {

        setSubmitted(true);


        let _genericasSistema = [...genericasSistema];
        if (idOriginal > 0) {
            const index = findIndexById(genericaFormulario.id);

            _genericasSistema[index] = _genericaSistema;

            /*var newLazyParam = Object.assign({}, lazyParams);
            newLazyParam.iteracion = newLazyParam.iteracion+1;
            
            setLazyParams(newLazyParam);
            */
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });

        }
        else {
            //console.log("unshift, ",_genericaSistema);
            //_genericaSistema.image = 'genericaSistema-placeholder.svg';
            _genericasSistema.unshift(_genericaSistema);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });
        }

        setGenericasSistema(_genericasSistema);
        setGenericaSistemaDialogFormulario(false);
        setGenericaFormulario(crearNewEmptyGenerica(metadataGenericaFormulario));

    }

    const onSaveSuccessfulFormularioGenerico = (_genericaSistema, idOriginal, idtgAffect, tgAffect, valuesAffected) => {

        console.log("onSaveSuccessfulFormularioGenerico;");

        setSubmitted(true);

        if (_genericaSistema instanceof Array && (_genericaSistema[0].tg === "BPM_VSTA_CLONE_SOLICITUD_CD_INTENTO_CALCULADORA_COMPLETAR_INGRESO"
            || _genericaSistema[0].tg === "BPM_ADT_INTENTO_DILIGENCIAMIENTO_VERIFICACION_PAGARE")

        ) {
            hideDialog();
            if (props.onSaveSuccessfull) {
                props.onSaveSuccessfull();
            }

            setLazyParams({ ...lazyParams });

        }

        else if (_genericaSistema.tg === "BPM_VSTA_CLONE_SOLICITUD_CD_INTENTO_CALCULADORA_COMPLETAR_INGRESO") {
            hideDialog();
            if (props.onSaveSuccessfull) {
                props.onSaveSuccessfull();
            }
        }

        else if (_genericaSistema.uts["formato"] !== undefined && genericasSistema.length > 0 && genericasSistema[0].uts["formato"] !== undefined) {

            let formato = _genericaSistema.uts["formato"];
            let _genericasSistema = [...genericasSistema.filter(x => x.uts["formato"] !== formato)];

            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });
            setGenericaSistemaDialogFormularioFactura(false);
            setGenericasSistema(_genericasSistema);


        }
        else {

            let _genericasSistema = [...genericasSistema];
            if (idOriginal > 0) {
                const index = findIndexById(genericaFormulario.id);

                _genericasSistema[index] = _genericaSistema;

                /*var newLazyParam = Object.assign({}, lazyParams);
                newLazyParam.iteracion = newLazyParam.iteracion+1;
                
                setLazyParams(newLazyParam);
                */
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Actualizado', life: 3000 });

            }
            else {
                //console.log("unshift, ",_genericaSistema);
                //_genericaSistema.image = 'genericaSistema-placeholder.svg';
                _genericasSistema.unshift(_genericaSistema);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Guardado', life: 3000 });
            }

            setGenericasSistema(_genericasSistema);

        }

        setGenericaSistemaDialogFormulario(false);

        setGenericaFormulario(crearNewEmptyGenerica(metadataGenericaFormulario));


    }

    const template = (options) => {
        const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
        const className = `${options.className} justify-content-start`;
        const titleClassName = `${options.titleClassName} pl-1`;

        return (
            <div className={className}>
                <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                    <span className={toggleIcon}></span>
                    <Ripple />
                </button>
                <span className={titleClassName}>
                    Header
                </span>
            </div>
        )
    }

    const templateFormulario = () => {
        console.log("templateFormulario,");
        if (genericaSistemaDialogFormulario === true) {



            return (<Formulario ref={formRef} genericaSistemaDialog={genericaSistemaDialogFormulario} genericaSistema={genericaFormulario}
                metadataGenericaSistemaForm={metadataGenericaFormulario}
                etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormulario}
                onHideForm={hideDialog} onSaveSuccessful={onSaveSuccessfulFormulario}></Formulario>)



        }
        else if (genericaSistemaDialogFormularioFactura === true && selectedTipoGenericaFormularioFactura.tg === "BPM_VSTA_SOLICITUD_GEN_ASESOR_MOD_NEW_STEP") {
            return (


                <FormularioStep ref={formFacturaRef} genericaSistemaDialog={genericaSistemaDialogFormularioFactura} genericaSistema={genericaFormularioFactura}
                    metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioFactura}
                    onHideForm={hideDialog} onSaveSuccessful={onSaveSuccessfulFormularioGenerico}

                //name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                //                          label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                //                        addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu}
                //                      genericaSistemaDialog={true}
                //                    etiquetasModulo={[{ 'hola': 'hola' }]}

                ></FormularioStep>
            );
        }

        else (<></>);
    }

    const templateFormularioFactura = () => {

        console.log("templateFormularioFactura,");

        if (genericaSistemaDialogFormularioFactura === true) {
            if (selectedTipoGenericaFormularioFactura.tipoOrganizacionContenido === "FORM_CALIFICACION") {
                return (<FormularioCalificacionRA ref={formFacturaRef} genericaSistemaDialog={genericaSistemaDialogFormularioFactura} genericaSistema={genericaFormularioFactura}
                    metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioFactura}
                    onHideForm={hideDialog} onSaveSuccessful={onSaveSuccessfulFormularioFactura}></FormularioCalificacionRA>);
            }
            else if (selectedTipoGenericaFormularioFactura.tipoOrganizacionContenido === "FORM_GENERICA") {
                return (<FormularioGenerico ref={formFacturaRef} genericaSistemaDialog={genericaSistemaDialogFormularioFactura} genericaSistema={genericaFormularioFactura}
                    metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioFactura}
                    onHideForm={hideDialog} onSaveSuccessful={onSaveSuccessfulFormularioGenerico}></FormularioGenerico>);
            }
            else if (selectedTipoGenericaFormularioFactura.tipoOrganizacionContenido === "FORMULARIO_STEPS") {
                return (


                    <FormularioStep ref={formFacturaRef} genericaSistemaDialog={genericaSistemaDialogFormularioFactura} genericaSistema={genericaFormularioFactura}
                        metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                        etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioFactura}
                        onHideForm={hideDialog} onSaveSuccessful={onSaveSuccessfulFormularioGenerico}

                    //name={props.name} level={props.level} codMenu={props.codMenu} onSelectionChange={onSelectionChangeCardRef}
                    //                          label={props.label} selectedTipoGenerica={selectedTipoGenericaRef}
                    //                        addSubTabMenu={props.addSubTabMenu} onAfterDeleteTab={props.onAfterDeleteTab} onSelectedFromMenu={props.onSelectedFromMenu}
                    //                      genericaSistemaDialog={true}
                    //                    etiquetasModulo={[{ 'hola': 'hola' }]}

                    ></FormularioStep>
                );
            }
            else if (selectedTipoGenericaFormularioFactura.tg === "BPM_VSTA_SOLICITUD_CD_INVITADO_REFERENCIA_ORDEN_ACADEMICA_CALCULADORA" || selectedTipoGenericaFormularioFactura.tg === "BPM_VSTA_SOLICITUD_CD_ASESOR_REFERENCIA_ORDEN_ACADEMICA_CALCULADORA") {
                return (<FormularioCalculadoraCredito ref={formFacturaRef} genericaSistemaDialog={genericaSistemaDialogFormularioFactura} genericaSistema={genericaFormularioFactura}
                    metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioFactura}
                    onHideForm={hideDialog} onSaveSuccessful={onSaveSuccessfulFormularioGenerico}></FormularioCalculadoraCredito>);
            }
            else if (selectedTipoGenericaFormularioFactura.tg === "BPM_VSTA_SOLICITUD_CD_INVITADO_VERIFICACION_PAGARE" || selectedTipoGenerica.tg === "BPM_VSTA_SOLICITUD_CD_INVITADO_VERIFICACION_PAGARE_CODEUDOR") {
                return (<FormularioVerificacionPagare ref={formFacturaRef} genericaSistemaDialog={genericaSistemaDialogFormularioFactura} genericaSistema={genericaFormularioFactura}
                    metadataGenericaSistemaForm={metadataGenericaFormularioFactura}
                    etiquetasModulo={etiquetasModulo} selectedTipoGenerica={selectedTipoGenericaFormularioFactura}
                    onHideForm={hideDialog} onSaveSuccessful={onSaveSuccessfulFormularioGenerico}></FormularioVerificacionPagare>);
            }

        }
        else (<></>);
    }

    const tipoOperacionesRow = ["EDIT", "EDIT_F", "REPORT", "LIST", "SEND_EMAIL", "EVAL_ROW", 'VIEW_REPORT'
        , '_ROW_LIST', '_ROW_EDIT', '_ROW_REPORT'];

    const tipoOperacionesRow2 = ["EDIT2", "EDIT_F2", "REPORT2", "LIST2", "SEND_EMAIL2", "EVAL_ROW2", 'VIEW_REPORT2'
        , '_ROW_LIST2', '_ROW_EDIT2', '_ROW_REPORT2'];

    const actionBodyTemplate = (rowData, options) => {

        const esPrimeraFila = options.rowIndex === 0;

        let ___ROWOPS = [];

        if (rowData.uts["___ROWOPS"] !== undefined && rowData.uts["___ROWOPS"] !== "") {
            ___ROWOPS = (rowData.uts["___ROWOPS"] + "").split(',');
        }

        return (
            <div className="actions">
                {
                    selectedTipoGenerica.operaciones.filter(x => tipoOperacionesRow.includes(x.tipoOperacion))
                        .map((x, index) => {
                            let esROWOPS = x.tipoOperacion.substring(0, 5) === "_ROW_";

                            if (esROWOPS) {
                                let dddd = "";
                            }

                            //console.log("visibleTextButton, ", visibleTextButton)
                            let textLabel = visibleTextButton === true ? x.ctiTexto : undefined;


                            if (esROWOPS === false && (x.tipoOperacion !== "SEND_EMAIL" || (x.tipoOperacion === "SEND_EMAIL" && !rowData.uts["enviado"]))) {

                                return (<Button key={index} icon={x.icono} idopsgenerica={x.id} className="p-button-rounded p-button-success mr-2" tooltip={x.ctiTexto}
                                    label={textLabel} aria-label={x.ctiTexto} ref={esPrimeraFila ? primerBotonRef : null} 
                                    onClick={(e) => {
                                        switch (x.tipoOperacion) {
                                            case "EDIT": editGenericaSistemaFormulario(e, rowData); break;
                                            case "EVAL_ROW": editGenericaSistemaFormulario(e, rowData); break;
                                            case "EDIT_F": editGenericaSistemaFormularioFactura(e, rowData); break;
                                            case "REPORT": reportarEvidencia(e, rowData); break;
                                            case "LIST": verListaAsociada(e, rowData); break;
                                            case "SEND_EMAIL": sendMailGenerica(e, rowData); break;
                                            case "VIEW_REPORT": verReport(e, rowData); break;

                                        }
                                    }}
                                />)

                            }
                            else if (esROWOPS === true) {
                                let patternOps = x.tipoOperacion + "(" + x.ordenGrupo + ")";
                                esROWOPS = ___ROWOPS.includes(patternOps);

                                if (esROWOPS) {
                                    return (<Button key={index + x.tipoOperacion + x.tgRef} icon={x.icono} idopsgenerica={x.id} className="p-button-rounded p-button-success mr-2"
                                        tooltip={x.ctiTexto} label={textLabel} aria-label={x.ctiTexto} ref={esPrimeraFila ? primerBotonRef : null} 
                                        onClick={(e) => {
                                            switch (x.tipoOperacion) {
                                                case "_ROW_REPORT":
                                                    //if (___ROWOPS.includes(patternOps)) {
                                                    reportarEvidencia(e, rowData);
                                                    //}

                                                    break;

                                                case "_ROW_EDIT":
                                                    //if (___ROWOPS.includes(patternOps)) {
                                                    editGenericaSistemaFormulario(e, rowData);
                                                    //}

                                                    break;

                                                case "_ROW_LIST":
                                                    //if (___ROWOPS.includes(patternOps)) {
                                                    verListaAsociada(e, rowData); break;
                                                    //}

                                                    break;

                                            }
                                        }}
                                    />)
                                }
                                else
                                    return (<></>);

                            }
                            else {
                                return (<></>);
                            }

                        }
                        )
                }
            </div>
        );
    }

    const cardDataAndActionBodyTemplate = (rowData, options) => {




        return (<>
            {actionBodyTemplate(rowData, options)}

            <Card  >
                <div className='grid'>
                    {cardBodyTemplate(rowData, options)}
                </div>
            </Card>
        </>);
    }

    const footerBodyActionTemplate = () => {

        let rowData = selectedGenericasSistema;

        if (rowData === null || rowData === undefined || rowData.tg === null) {
            return (<></>);
        }
        else {
            let ___ROWOPS = [];

            if (rowData.uts["___ROWOPS"] !== undefined && rowData.uts["___ROWOPS"] !== "") {
                ___ROWOPS = (rowData.uts["___ROWOPS"] + "").split(',');
            }

            return (<>
                <br></br>
                <div className="card flex justify-content-centeractions">
                    {
                        selectedTipoGenerica.operaciones.filter(x => tipoOperacionesRow2.includes(x.tipoOperacion))
                            .map((x, index) => {
                                let esROWOPS = x.tipoOperacion.substring(0, 5) === "_ROW_";

                                if (esROWOPS) {
                                    let dddd = "";
                                }

                                if (esROWOPS === false && (x.tipoOperacion !== "SEND_EMAIL" || (x.tipoOperacion === "SEND_EMAIL" && !rowData.uts["enviado"]))) {

                                    return (<Button key={index + x.tipoOperacion + x.tgRef} icon={x.icono} idopsgenerica={x.id} className="p-button-rounded p-button-success mr-2" label={x.ctiTexto} tooltip={x.ctiTexto} aria-label={x.ctiTexto}
                                        onClick={(e) => {
                                            switch (x.tipoOperacion) {
                                                case "EDIT2": editGenericaSistemaFormulario(e, rowData); break;
                                                case "EVAL_ROW2": editGenericaSistemaFormulario(e, rowData); break;
                                                case "EDIT_F2": editGenericaSistemaFormularioFactura(e, rowData); break;
                                                case "REPORT2": reportarEvidencia(e, rowData); break;
                                                case "LIST2": verListaAsociada(e, rowData); break;
                                                case "SEND_EMAIL2": sendMailGenerica(e, rowData); break;
                                                case "VIEW_REPORT2": verReport(e, rowData); break;

                                            }
                                        }}
                                    />)

                                }
                                else if (esROWOPS === true) {
                                    let patternOps = x.tipoOperacion + "(" + x.ordenGrupo + ")";
                                    esROWOPS = ___ROWOPS.includes(patternOps);

                                    if (esROWOPS) {
                                        return (<Button key={index + x.tipoOperacion + x.tgRef} icon={x.icono} idopsgenerica={x.id} className="p-button-rounded p-button-success mr-2" label={x.ctiTexto} tooltip={x.ctiTexto} aria-label={x.ctiTexto}
                                            onClick={(e) => {
                                                switch (x.tipoOperacion) {
                                                    case "_ROW_REPORT2":
                                                        //if (___ROWOPS.includes(patternOps)) {
                                                        reportarEvidencia(e, rowData);
                                                        //}

                                                        break;

                                                    case "_ROW_EDIT2":
                                                        //if (___ROWOPS.includes(patternOps)) {
                                                        editGenericaSistemaFormulario(e, rowData);
                                                        //}

                                                        break;

                                                    case "_ROW_LIST2":
                                                        //if (___ROWOPS.includes(patternOps)) {
                                                        verListaAsociada(e, rowData); break;
                                                        //}

                                                        break;

                                                }
                                            }}
                                        />)
                                    }
                                    else
                                        return (<></>);

                                }
                                else {
                                    return (<></>);
                                }

                            }
                            )
                    }
                </div>
            </>
            );
        }

    }


    if (lazyParams === undefined || selectedTipoGenerica === undefined || !selectedTipoGenerica.tg || !selectedTipoGenerica.tg === "" ||
        selectedTipoGenerica.operaciones === undefined || metadataGenericaSistema.length === 0 || genericaFormulario === undefined || optionsSelectButton === undefined) { //|| selectedTipoGenericaFormulario === undefined) {

        return (<DataTable value={arrayTemplate} className="p-datatable-striped" header={bodyTemplate}>
            <Column field="code" header="Code" style={{ width: '25%' }} body={bodyTemplate}></Column>
            <Column field="name" header="Name" style={{ width: '25%' }} body={bodyTemplate}></Column>
        </DataTable>)
    }

    else if (selectedTipoGenerica.operaciones === undefined) {

        return (<span>No se encuentran permisos asociados</span>)
    }



    //  Esto es para visualizar tipo card
    else if (selectedTipoGenerica.factorFormaDato === "CARD") {

        //if(props.selectedTipoGenerica.tg ==="BAS_MACROPROCESO" )
        //console.log("DataTableGenerica props",  selectedTipoGenerica , "selectedTipoGenerica, ", selectedTipoGenerica);
        //console.log("selectedColumns, ", selectedColumns);

        return (
            <div style={{ width: '100%', overflowX: 'hidden' }}>

                <Toast ref={toast} comodin={comodin} />

                <DataTable lazy value={genericasSistema} dataKey="indexRow" ref={dt} loading={loading}

                    header={header()} // filterDisplay="row" 
                    //paginator first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords}
                    //rowsPerPageOptions={[5, 10, 25, 100, 250, 10000]}
                    onPage={onPage} size="normal"
                    //onFilter={onFilter} filters={lazyParams.filters} 
                    //onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    //selection={selectedGenericasSistema} onSelectionChange={onSelectionChange}
                    //resizableColumns columnResizeMode="expand" filterLocale="es"
                    //selectAll={selectAll} 
                    //onSelectAllChange={onSelectAllChange}
                    //globalFilter={globalFilter} 
                    emptyMessage={GetTextoEtiqueta("LABEL_EMPTY_MESSAGE")}

                //selectionMode="single"
                //paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                //reorderableColumns={true} currentPageReportTemplate="{first} to {last} of {totalRecords}"
                >
                    <Column key="cardDataAndActionBodyTemplate" body={cardDataAndActionBodyTemplate} ></Column>


                </DataTable>

                {templateFormulario()}
                {templateFormularioFactura()}

                {footerBodyActionTemplate()}

                <Dialog visible={deletegenericaSistemaDialogFormulario} style={{ width: '450px' }} header="Confirm" modal footer={deletegenericaSistemaDialogFormularioFooter} onHide={hidedeletegenericaSistemaDialogFormulario}>
                </Dialog>

                <Dialog visible={deletegenericasSistemaDialog} style={{ width: '450px' }} header="Confirm" modal footer={deletegenericasSistemaDialogFooter} onHide={hidedeletegenericasSistemaDialog}>

                </Dialog>

                <Dialog visible={dialogTextVisible} style={{ width: '90vw' }} onHide={() => setDialogTextVisible(false)}>

                    <div className="m-0" dangerouslySetInnerHTML={{ __html: dialogText }} />

                </Dialog>

            </div>
        );

    }

    else {

        //if(props.selectedTipoGenerica.tg ==="BAS_MACROPROCESO" )
        //console.log("DataTableGenerica props",  selectedTipoGenerica , "selectedTipoGenerica, ", selectedTipoGenerica);
        //console.log("selectedColumns, ", selectedColumns);

        return (
            <div style={{ width: '100%', overflowX: 'hidden', padding: "0", margin: "0" }}>

                <Toast ref={toast} comodin={comodin} />

                <DataTable lazy value={genericasSistema} dataKey="indexRow"
                    header={header()} filterDisplay="row" ref={dt}
                    paginator first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25, 100, 250, 10000]}
                    onPage={onPage} size="small"
                    onFilter={onFilter} filters={lazyParams.filters} loading={loading}
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    selection={selectedGenericasSistema} onSelectionChange={onSelectionChange}
                    resizableColumns columnResizeMode="expand" filterLocale="es"

                    //selectAll={selectAll} 
                    //onSelectAllChange={onSelectAllChange}
                    //globalFilter={globalFilter} 
                    emptyMessage={GetTextoEtiqueta("LABEL_EMPTY_MESSAGE")}
                    editMode="cell"
                    onCellSelect={(e) => {
                        // Si la celda es editable, puedes forzar la apertura o lógica
                        if (canEditRow(e.rowData)) {
                            // Tu lógica o permitir que el doble clic/evento secundario maneje el foco
                        }
                    }}

                    responsiveLayout="scroll" selectionMode="single"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    reorderableColumns={true} currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    className='tabla-adaptable'
                >
                    <Column key="actionBody" body={actionBodyTemplate} ></Column>
                    {columnsDataTable}

                </DataTable>

                {templateFormulario()}
                {templateFormularioFactura()}

                {footerBodyActionTemplate()}

                <Dialog visible={deletegenericaSistemaDialogFormulario} style={{}} header="Confirm" modal footer={deletegenericaSistemaDialogFormularioFooter} onHide={hidedeletegenericaSistemaDialogFormulario}>
                </Dialog>

                <Dialog visible={deletegenericasSistemaDialog} style={{}} header="Confirm" modal footer={deletegenericasSistemaDialogFooter} onHide={hidedeletegenericasSistemaDialog}>

                </Dialog>

                <Dialog visible={dialogTextVisible} style={{ width: '90vw' }} onHide={() => setDialogTextVisible(false)}>

                    <div className="m-0" dangerouslySetInnerHTML={{ __html: dialogText }} />

                </Dialog>

            </div>
        );

    }

});

/*const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(DataTableGenerica, comparisonFn);*/
export default DataTableGenerica;

